import { TableClass } from '../../../world/spa/libs/classes';

export default {
	worldResourceEventType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'generic',
				it: "Generico",
				en: "Generic"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'vehicle',
				it: "Veicolo",
				en: "Vehicle"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'notAvaiable',
				it: "Non Disponibile",
				en: "Not Avaiable"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'close',
				it: "Chiuso",
				en: "Close"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'reservation',
				it: "Prenotazione",
				en: "Reservation"
			}
		});
	},
	worldMailType() {
		return new TableClass({
			0: {
				typeClass: 0,
				typeClassLiteral: 'other',
				it: "Altro",
				en: "Other"
			},
			1: {
				typeClass: 1,
				typeClassLiteral: 'google',
				it: "Google",
				en: "Google"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'outlook',
				it: "Outlook",
				en: "Outlook"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'aruba',
				it: "Aruba",
				en: "Aruba"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'arubaBusiness',
				it: "ArubaBusiness",
				en: "ArubaBusiness"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'yahoo',
				it: "Yahoo",
				en: "Yahoo"
			}
		});
	},
	resourceLicenseCategory() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'generic',
				it: "Generico",
				en: "Generic"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'restaurant',
				it: "Ristorante",
				en: "Restaurant"
			}
		});
	},
	deferment() {
		return new TableClass({
			'seenBill': {
				typeClass: 1,
				typeClassLiteral: 'seenBill',
				it: "Vista fattura",
				en: "Seen bill"
			},
			'30': {
				typeClass: 2,
				typeClassLiteral: '30',
				it: "30",
				en: "30"
			},
			'3060': {
				typeClass: 3,
				typeClassLiteral: '3060',
				it: "30-60",
				en: "30-60"
			},
			'60': {
				typeClass: 4,
				typeClassLiteral: '60',
				it: "60",
				en: "60"
			},
			'6090': {
				typeClass: 5,
				typeClassLiteral: '6090',
				it: "60-90",
				en: "60-90"
			},
			'90': {
				typeClass: 6,
				typeClassLiteral: '90',
				it: "90",
				en: "90"
			}
		});
	},
	worldMedicalVisitType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'sport',
				it: "Sportiva agonistica",
				en: "Agonistic sport"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'generic',
				it: "Generica",
				en: "Generic"
			}
		});
	},
	worldGender() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'm',
				it: "Maschio",
				en: "Male"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'f',
				it: "Femmina",
				en: "Female"
			}
		});
	},
	editType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'insert',
				it: "Inserimento",
				en: "Insert"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'update',
				it: "Aggiornamento",
				en: "Update"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'delete',
				it: "Cancellazione",
				en: "Delete"
			}
		});
	},
	worldResourceEventStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'notArrived',
				it: "Non Arrivato",
				en: "Not Arrived"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'running',
				it: "In Corso",
				en: "Running"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'closed',
				it: "Servito",
				en: "Completed"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'annulled',
				it: "Annullato",
				en: "Annulled"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'noShow',
				it: "Non Presentato",
				en: "No Show"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'notConfirmed',
				it: "Non Confermato",
				en: "Not Confirmed"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'confirmed',
				it: "Confermato",
				en: "Confirmed"
			}
		});
	},
	employmentPermission() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'superuser',
				it: "Superuser",
				en: "Superuser"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'manager',
				it: "Manager",
				en: "Manager"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'analyst',
				it: "Amministrazione",
				en: "Analyst"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'supervisor',
				it: "Supervisore",
				en: "Supervisor"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'technician',
				it: "Tecnico",
				en: "Technician"
			}
		});
	},
	worldResourceStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'free',
				it: "Libero",
				en: "Free"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'busy',
				it: "Non disponibile",
				en: "Busy"
			}
		});
	},
	worldPaymentModeType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'cash',
				it: "Contanti",
				en: "Cash"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'debitCard',
				it: "Carta di debito",
				en: "Debit card"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'creditCard',
				it: "Carta di credito",
				en: "Credit card"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'transfer',
				it: "Bonifico",
				en: "Tranfer"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'check',
				it: "Assegno",
				en: "Check"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'bankReceipt',
				it: "Ri.ba.",
				en: "Bank receipt"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'ybAccount',
				it: "Conto Spiagge.it",
				en: "Spiagge.it account"
			},
			8: {
				typeClass: 8,
				typeClassLiteral: 'other',
				it: "Altro",
				en: "Other"
			},
			9: {
				typeClass: 9,
				typeClassLiteral: 'pay',
				it: "Tessera",
				en: "Pay Card"
			},
			10: {
				typeClass: 10,
				typeClassLiteral: 'satispay',
				it: "Satispay",
				en: "Satispay"
			}
		});
	},
	worldReceiptType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'receipt',
				it: "Scontrino",
				en: "Receipt"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'invoice',
				it: "Fattura",
				en: "Invoice"
			}
		});
	},
	worldOutgoVerificationType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'verified',
				it: "Verificata automaticamente",
				en: "Automatically verified"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'imported',
				it: "Spesa importata",
				en: "Imported Expense"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'manuallyVerified',
				it: "Verificata manualmente",
				en: "Manually verified"
			}
		});
	},
	workVerifyLevel() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: '0',
				it: "Non verificato",
				en: "Not verified"
			}
		});
	},
	worldLocationType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'generic',
				it: "Generico",
				en: "Generic"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'network',
				it: "Network",
				en: "Network"
			}
		});
	},
	worldOutgoApprovalStatus() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'requested',
				it: "Approvazione richiesta",
				en: "Approval requested"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'approved',
				it: "Approvata",
				en: "Approved"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'rejected',
				it: "Rigettata",
				en: "Rejected"
			}
		});
	},
	worldMonth() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'january',
				it: "Gennaio",
				en: "Gennaio"
			}
		});
	},
	worldWeekDay() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'monday',
				it: "Lunedì",
				en: "Monday"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'tuesday',
				it: "Martedì",
				en: "Tuesday"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'wednesday',
				it: "Mercoledì",
				en: "Wednesday"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'thursday',
				it: "Giovedì",
				en: "Thursday"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'friday',
				it: "Venerdì",
				en: "Friday"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'saturday',
				it: "Sabato",
				en: "Saturday"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'sunday',
				it: "Domenica",
				en: "Sunday"
			}
		});
	},
	dailyPayValueCateogory() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'no',
				it: "No",
				en: "No"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'variable',
				it: "Variabile",
				en: "Variable"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'fixed',
				it: "Fissa",
				en: "Fixed"
			}
		});
	},
	worldTimezone() {
		return new TableClass({
			'Pacific/Midway': {
				typeClass: 1,
				typeClassLiteral: 'Pacific/Midway',
				it: "(UTC-11:00) Midway Islands",
				en: "(UTC-11:00) Midway Islands"
			},
			'America/Adak': {
				typeClass: 2,
				typeClassLiteral: 'America/Adak',
				it: "(UTC-10:00) Hawaii",
				en: "(UTC-10:00) Hawaii"
			},
			'Pacific/Marquesas': {
				typeClass: 3,
				typeClassLiteral: 'Pacific/Marquesas',
				it: "(UTC-09:30) Isole Marchesi",
				en: "(UTC-09:30) Marquesas Islands"
			},
			'America/Anchorage': {
				typeClass: 4,
				typeClassLiteral: 'America/Anchorage',
				it: "(UTC-09:00) Alaska",
				en: "(UTC-09:00) Alaska"
			},
			'America/Los_Angeles': {
				typeClass: 5,
				typeClassLiteral: 'America/Los_Angeles',
				it: "(UTC-08:00) Pacific Time (US e Canada)",
				en: "(UTC-08:00) Pacific Time (US & Canada)"
			},
			'America/Denver': {
				typeClass: 6,
				typeClassLiteral: 'America/Denver',
				it: "(UTC-07:00) Mountain Time (US e Canada)",
				en: "(UTC-07:00) Mountain Time (US & Canada)"
			},
			'America/Chicago': {
				typeClass: 7,
				typeClassLiteral: 'America/Chicago',
				it: "(UTC-06:00) Central Time (US e Canada)",
				en: "(UTC-06:00) Central Time (US & Canada)"
			},
			'America/New_York': {
				typeClass: 8,
				typeClassLiteral: 'America/New_York',
				it: "(UTC-05:00) Eastern Time (US e Canada)",
				en: "(UTC-05:00) Eastern Time (US & Canada)"
			},
			'America/Caracas': {
				typeClass: 9,
				typeClassLiteral: 'America/Caracas',
				it: "(UTC-04:00) Citt� di Caracas",
				en: "(UTC-04:00) City of Caracas"
			},
			'America/Argentina/Buenos_Aires': {
				typeClass: 10,
				typeClassLiteral: 'America/Argentina/Buenos_Aires',
				it: "(UTC-03:00) Citt� di Buenos Aires",
				en: "(UTC-03:00) City of Buenos Aires"
			},
			'Atlantic/South_Georgia': {
				typeClass: 11,
				typeClassLiteral: 'Atlantic/South_Georgia',
				it: "(UTC-02:00) South Georgia",
				en: "(UTC-02:00) South Georgia"
			},
			'Atlantic/Azores': {
				typeClass: 12,
				typeClassLiteral: 'Atlantic/Azores',
				it: "(UTC-01:00) Isole Azzorre",
				en: "(UTC-01:00) Azores Islands"
			},
			'Europe/London': {
				typeClass: 13,
				typeClassLiteral: 'Europe/London',
				it: "(UTC) Dublin, Edinburgh, Lisbon, London",
				en: "(UTC) Dublin, Edinburgh, Lisbon, London"
			},
			'Europe/Rome': {
				typeClass: 14,
				typeClassLiteral: 'Europe/Rome',
				it: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
				en: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
			},
			'Africa/Cairo': {
				typeClass: 15,
				typeClassLiteral: 'Africa/Cairo',
				it: "(UTC+02:00) Kiev, Cairo, Citt� del Capo",
				en: "(UTC+02:00) Kiev, Cairo, Cape Town"
			},
			'Asia/Riyadh': {
				typeClass: 16,
				typeClassLiteral: 'Asia/Riyadh',
				it: "(UTC+03:00) Kuwait, Riyadh",
				en: "(UTC+03:00) Kuwait, Riyadh"
			},
			'Europe/Moscow': {
				typeClass: 17,
				typeClassLiteral: 'Europe/Moscow',
				it: "(UTC+03:00) Moscow, St. Petersburg, Volgograd (RTZ2)",
				en: "(UTC+03:00) Moscow, St. Petersburg, Volgograd (RTZ2)"
			},
			'Asia/Tehran': {
				typeClass: 18,
				typeClassLiteral: 'Asia/Tehran',
				it: "(UTC+03:30) Teheran",
				en: "(UTC+03:30) Tehran"
			},
			'Asia/Muscat': {
				typeClass: 19,
				typeClassLiteral: 'Asia/Muscat',
				it: "(UTC+04:00) Abu Dhabi, Muscat",
				en: "(UTC+04:00) Abu Dhabi, Muscat"
			},
			'Asia/Kabul': {
				typeClass: 20,
				typeClassLiteral: 'Asia/Kabul',
				it: "(UTC+04:30) Kabul",
				en: "(UTC+04:30) Kabul"
			},
			'Asia/Yekaterinburg': {
				typeClass: 21,
				typeClassLiteral: 'Asia/Yekaterinburg',
				it: "(UTC+05:00) Yekaterimburg, Ashgabat, Islamabad",
				en: "(UTC+05:00) Yekaterimburg, Ashgabat, Islamabad"
			},
			'Asia/Kolkata': {
				typeClass: 22,
				typeClassLiteral: 'Asia/Kolkata',
				it: "(UTC+05:30) Chennai, Kolkata, Mumbai, Nuova Delhi",
				en: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
			},
			'Asia/Kathmandu': {
				typeClass: 23,
				typeClassLiteral: 'Asia/Kathmandu',
				it: "(UTC+05:45) Kathmandu",
				en: "(UTC+05:45) Kathmandu"
			},
			'Asia/Almaty': {
				typeClass: 24,
				typeClassLiteral: 'Asia/Almaty',
				it: "(UTC+06:00) Astana, Almaty, Omsk",
				en: "(UTC+06:00) Astana, Almaty, Omsk"
			},
			'Asia/Rangoon': {
				typeClass: 25,
				typeClassLiteral: 'Asia/Rangoon',
				it: "(UTC+06:30) Rangoon",
				en: "(UTC+06:30) Rangoon"
			},
			'Asia/Jakarta': {
				typeClass: 26,
				typeClassLiteral: 'Asia/Jakarta',
				it: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
				en: "(UTC+07:00) Bangkok, Hanoi, Jakarta"
			},
			'Asia/Hong_Kong': {
				typeClass: 27,
				typeClassLiteral: 'Asia/Hong_Kong',
				it: "(UTC+08:00) Beijing, Chongquing, Hong Kong, Urumqui",
				en: "(UTC+08:00) Beijing, Chongquing, Hong Kong, Urumqui"
			},
			'Asia/Kuala_Lumpur': {
				typeClass: 28,
				typeClassLiteral: 'Asia/Kuala_Lumpur',
				it: "(UTC+08:00) Kuala Lumpur, Singapore",
				en: "(UTC+08:00) Kuala Lumpur, Singapore"
			},
			'Australia/Perth': {
				typeClass: 29,
				typeClassLiteral: 'Australia/Perth',
				it: "(UTC+08:00) Perth",
				en: "(UTC+08:00) Perth"
			},
			'Asia/Tokyo': {
				typeClass: 30,
				typeClassLiteral: 'Asia/Tokyo',
				it: "(UTC+09:00) Osaka, Sapporo, Tokio, Seul",
				en: "(UTC+09:00) Osaka, Sapporo, Tokio, Seoul"
			},
			'Australia/Adelaide': {
				typeClass: 31,
				typeClassLiteral: 'Australia/Adelaide',
				it: "(UTC+09:30) Adelaide, Darwin",
				en: "(UTC+09:30) Adelaide, Darwin"
			},
			'Australia/Melbourne': {
				typeClass: 32,
				typeClassLiteral: 'Australia/Melbourne',
				it: "(UTC+10:00) Canberra, Melbourne, Sydney",
				en: "(UTC+10:00) Canberra, Melbourne, Sydney"
			},
			'Australia/Lord_Howe': {
				typeClass: 33,
				typeClassLiteral: 'Australia/Lord_Howe',
				it: "(UTC+10:30) Isola di Lord Howe",
				en: "(UTC+10:30) Lord Howe Island"
			},
			'Asia/Magadan': {
				typeClass: 34,
				typeClassLiteral: 'Asia/Magadan',
				it: "(UTC+11:00) Isole Salomone, Bouganville, Magadan",
				en: "(UTC+11:00) Solomon Islands, Bouganville, Magadan"
			},
			'Pacific/Auckland': {
				typeClass: 35,
				typeClassLiteral: 'Pacific/Auckland',
				it: "(UTC+12:00) Auckland, Wellington, Fiji",
				en: "(UTC+12:00) Auckland, Wellington, Fiji"
			},
			'Pacific/Chatham': {
				typeClass: 36,
				typeClassLiteral: 'Pacific/Chatham',
				it: "(UTC+12:45) Isole Chatham",
				en: "(UTC+12:45) Chatham Islands"
			},
			'Pacific/Samoa': {
				typeClass: 37,
				typeClassLiteral: 'Pacific/Samoa',
				it: "(UTC+13:00) Samoa",
				en: "(UTC+13:00) Samoa"
			},
			'Pacific/Kiritimati': {
				typeClass: 38,
				typeClassLiteral: 'Pacific/Kiritimati',
				it: "(UTC+14:00) Isole Kiritimati",
				en: "(UTC+14:00) Kiritimati Island"
			}
		});
	},
	worldDeliveryType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'beachUmbrella',
				it: "Ombrellone",
				en: "Beach umbrella"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'beachUmbrellaWithCover',
				it: "Ombrellone con tavolo",
				en: "Beach umbrella with table"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'pickUpChiringuito',
				it: "Ritiro presso chiringuito",
				en: "Pick up from chiringuito "
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'pickUpBar',
				it: "Ritiro presso bar",
				en: "Pick up from bar"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'table',
				it: "Tavolo",
				en: "Table"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'store',
				it: "Ritiro in negozio",
				en: "Pick up from store"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'homeDelivery',
				it: "Consegna a domicilio",
				en: "Home delivery"
			},
			8: {
				typeClass: 8,
				typeClassLiteral: 'pickUpRestaurant',
				it: "Ritiro presso ristorante",
				en: "Pick up from restaurant"
			},
			9: {
				typeClass: 9,
				typeClassLiteral: 'pickUpPoint',
				it: "Punto di ritiro",
				en: "Pick up point"
			},
			10: {
				typeClass: 10,
				typeClassLiteral: 'bungalow',
				it: "Bungalow",
				en: "Bungalow"
			},
			11: {
				typeClass: 11,
				typeClassLiteral: 'room',
				it: "Servizio in camera",
				en: "Room service"
			}
		});
	},
	worldWorkCostArea() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'national',
				it: "Nazionale",
				en: "National"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'continental',
				it: "Continentale",
				en: "Continental"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'intercontinental',
				it: "Intercontinentale",
				en: "Intercontinental"
			}
		});
	},
	boolean() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: '0',
				it: "No",
				en: "No"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: '1',
				it: "S�",
				en: "Yes"
			}
		});
	},
	worldCurrencyType() {
		return new TableClass({
			'EUR': {
				typeClass: 1,
				typeClassLiteral: 'EUR',
				it: "EUR",
				en: "EUR"
			},
			'USD': {
				typeClass: 2,
				typeClassLiteral: 'USD',
				it: "USD",
				en: "USD"
			},
			'GBP': {
				typeClass: 3,
				typeClassLiteral: 'GBP',
				it: "GBP",
				en: "GBP"
			},
			'INR': {
				typeClass: 4,
				typeClassLiteral: 'INR',
				it: "INR",
				en: "INR"
			},
			'AUD': {
				typeClass: 5,
				typeClassLiteral: 'AUD',
				it: "AUD",
				en: "AUD"
			},
			'CAD': {
				typeClass: 6,
				typeClassLiteral: 'CAD',
				it: "CAD",
				en: "CAD"
			},
			'SGD': {
				typeClass: 7,
				typeClassLiteral: 'SGD',
				it: "SGD",
				en: "SGD"
			},
			'CHF': {
				typeClass: 8,
				typeClassLiteral: 'CHF',
				it: "CHF",
				en: "CHF"
			},
			'MYR': {
				typeClass: 9,
				typeClassLiteral: 'MYR',
				it: "MYR",
				en: "MYR"
			},
			'JPY': {
				typeClass: 10,
				typeClassLiteral: 'JPY',
				it: "JPY",
				en: "JPY"
			},
			'CNY': {
				typeClass: 11,
				typeClassLiteral: 'CNY',
				it: "CNY",
				en: "CNY"
			},
			'NZD': {
				typeClass: 12,
				typeClassLiteral: 'NZD',
				it: "NZD",
				en: "NZD"
			},
			'THB': {
				typeClass: 13,
				typeClassLiteral: 'THB',
				it: "THB",
				en: "THB"
			},
			'HUF': {
				typeClass: 14,
				typeClassLiteral: 'HUF',
				it: "HUF",
				en: "HUF"
			},
			'AED': {
				typeClass: 15,
				typeClassLiteral: 'AED',
				it: "AED",
				en: "AED"
			},
			'HKD': {
				typeClass: 16,
				typeClassLiteral: 'HKD',
				it: "HKD",
				en: "HKD"
			},
			'MXN': {
				typeClass: 17,
				typeClassLiteral: 'MXN',
				it: "MXN",
				en: "MXN"
			},
			'ZAR': {
				typeClass: 18,
				typeClassLiteral: 'ZAR',
				it: "ZAR",
				en: "ZAR"
			},
			'PHP': {
				typeClass: 19,
				typeClassLiteral: 'PHP',
				it: "PHP",
				en: "PHP"
			},
			'SEK': {
				typeClass: 20,
				typeClassLiteral: 'SEK',
				it: "SEK",
				en: "SEK"
			},
			'IDR': {
				typeClass: 21,
				typeClassLiteral: 'IDR',
				it: "IDR",
				en: "IDR"
			},
			'SAR': {
				typeClass: 22,
				typeClassLiteral: 'SAR',
				it: "SAR",
				en: "SAR"
			},
			'BRL': {
				typeClass: 23,
				typeClassLiteral: 'BRL',
				it: "BRL",
				en: "BRL"
			},
			'TRY': {
				typeClass: 24,
				typeClassLiteral: 'TRY',
				it: "TRY",
				en: "TRY"
			},
			'KES': {
				typeClass: 25,
				typeClassLiteral: 'KES',
				it: "KES",
				en: "KES"
			},
			'KRW': {
				typeClass: 26,
				typeClassLiteral: 'KRW',
				it: "KRW",
				en: "KRW"
			},
			'EGP': {
				typeClass: 27,
				typeClassLiteral: 'EGP',
				it: "EGP",
				en: "EGP"
			},
			'IQD': {
				typeClass: 28,
				typeClassLiteral: 'IQD',
				it: "IQD",
				en: "IQD"
			},
			'NOK': {
				typeClass: 29,
				typeClassLiteral: 'NOK',
				it: "NOK",
				en: "NOK"
			},
			'KWD': {
				typeClass: 30,
				typeClassLiteral: 'KWD',
				it: "KWD",
				en: "KWD"
			},
			'RUB': {
				typeClass: 31,
				typeClassLiteral: 'RUB',
				it: "RUB",
				en: "RUB"
			},
			'DKK': {
				typeClass: 32,
				typeClassLiteral: 'DKK',
				it: "DKK",
				en: "DKK"
			},
			'PKR': {
				typeClass: 33,
				typeClassLiteral: 'PKR',
				it: "PKR",
				en: "PKR"
			},
			'ILS': {
				typeClass: 34,
				typeClassLiteral: 'ILS',
				it: "ILS",
				en: "ILS"
			},
			'PLN': {
				typeClass: 35,
				typeClassLiteral: 'PLN',
				it: "PLN",
				en: "PLN"
			},
			'QAR': {
				typeClass: 36,
				typeClassLiteral: 'QAR',
				it: "QAR",
				en: "QAR"
			},
			'XAU': {
				typeClass: 37,
				typeClassLiteral: 'XAU',
				it: "XAU",
				en: "XAU"
			},
			'OMR': {
				typeClass: 38,
				typeClassLiteral: 'OMR',
				it: "OMR",
				en: "OMR"
			},
			'COP': {
				typeClass: 39,
				typeClassLiteral: 'COP',
				it: "COP",
				en: "COP"
			},
			'CLP': {
				typeClass: 40,
				typeClassLiteral: 'CLP',
				it: "CLP",
				en: "CLP"
			},
			'TWD': {
				typeClass: 41,
				typeClassLiteral: 'TWD',
				it: "TWD",
				en: "TWD"
			},
			'ARS': {
				typeClass: 42,
				typeClassLiteral: 'ARS',
				it: "ARS",
				en: "ARS"
			},
			'CZK': {
				typeClass: 43,
				typeClassLiteral: 'CZK',
				it: "CZK",
				en: "CZK"
			},
			'VND': {
				typeClass: 44,
				typeClassLiteral: 'VND',
				it: "VND",
				en: "VND"
			},
			'MAD': {
				typeClass: 45,
				typeClassLiteral: 'MAD',
				it: "MAD",
				en: "MAD"
			},
			'JOD': {
				typeClass: 46,
				typeClassLiteral: 'JOD',
				it: "JOD",
				en: "JOD"
			},
			'BHD': {
				typeClass: 47,
				typeClassLiteral: 'BHD',
				it: "BHD",
				en: "BHD"
			},
			'XOF': {
				typeClass: 48,
				typeClassLiteral: 'XOF',
				it: "XOF",
				en: "XOF"
			},
			'LKR': {
				typeClass: 49,
				typeClassLiteral: 'LKR',
				it: "LKR",
				en: "LKR"
			},
			'UAH': {
				typeClass: 50,
				typeClassLiteral: 'UAH',
				it: "UAH",
				en: "UAH"
			},
			'NGN': {
				typeClass: 51,
				typeClassLiteral: 'NGN',
				it: "NGN",
				en: "NGN"
			},
			'TND': {
				typeClass: 52,
				typeClassLiteral: 'TND',
				it: "TND",
				en: "TND"
			},
			'UGX': {
				typeClass: 53,
				typeClassLiteral: 'UGX',
				it: "UGX",
				en: "UGX"
			},
			'RON': {
				typeClass: 54,
				typeClassLiteral: 'RON',
				it: "RON",
				en: "RON"
			},
			'BDT': {
				typeClass: 55,
				typeClassLiteral: 'BDT',
				it: "BDT",
				en: "BDT"
			},
			'PEN': {
				typeClass: 56,
				typeClassLiteral: 'PEN',
				it: "PEN",
				en: "PEN"
			},
			'GEL': {
				typeClass: 57,
				typeClassLiteral: 'GEL',
				it: "GEL",
				en: "GEL"
			},
			'XAF': {
				typeClass: 58,
				typeClassLiteral: 'XAF',
				it: "XAF",
				en: "XAF"
			},
			'FJD': {
				typeClass: 59,
				typeClassLiteral: 'FJD',
				it: "FJD",
				en: "FJD"
			},
			'VEF': {
				typeClass: 60,
				typeClassLiteral: 'VEF',
				it: "VEF",
				en: "VEF"
			},
			'BYN': {
				typeClass: 61,
				typeClassLiteral: 'BYN',
				it: "BYN",
				en: "BYN"
			},
			'HRK': {
				typeClass: 62,
				typeClassLiteral: 'HRK',
				it: "HRK",
				en: "HRK"
			},
			'UZS': {
				typeClass: 63,
				typeClassLiteral: 'UZS',
				it: "UZS",
				en: "UZS"
			},
			'BGN': {
				typeClass: 64,
				typeClassLiteral: 'BGN',
				it: "BGN",
				en: "BGN"
			},
			'DZD': {
				typeClass: 65,
				typeClassLiteral: 'DZD',
				it: "DZD",
				en: "DZD"
			},
			'IRR': {
				typeClass: 66,
				typeClassLiteral: 'IRR',
				it: "IRR",
				en: "IRR"
			},
			'DOP': {
				typeClass: 67,
				typeClassLiteral: 'DOP',
				it: "DOP",
				en: "DOP"
			},
			'ISK': {
				typeClass: 68,
				typeClassLiteral: 'ISK',
				it: "ISK",
				en: "ISK"
			},
			'XAG': {
				typeClass: 69,
				typeClassLiteral: 'XAG',
				it: "XAG",
				en: "XAG"
			},
			'CRC': {
				typeClass: 70,
				typeClassLiteral: 'CRC',
				it: "CRC",
				en: "CRC"
			},
			'SYP': {
				typeClass: 71,
				typeClassLiteral: 'SYP',
				it: "SYP",
				en: "SYP"
			},
			'LYD': {
				typeClass: 72,
				typeClassLiteral: 'LYD',
				it: "LYD",
				en: "LYD"
			},
			'JMD': {
				typeClass: 73,
				typeClassLiteral: 'JMD',
				it: "JMD",
				en: "JMD"
			},
			'MUR': {
				typeClass: 74,
				typeClassLiteral: 'MUR',
				it: "MUR",
				en: "MUR"
			},
			'GHS': {
				typeClass: 75,
				typeClassLiteral: 'GHS',
				it: "GHS",
				en: "GHS"
			},
			'AOA': {
				typeClass: 76,
				typeClassLiteral: 'AOA',
				it: "AOA",
				en: "AOA"
			},
			'UYU': {
				typeClass: 77,
				typeClassLiteral: 'UYU',
				it: "UYU",
				en: "UYU"
			},
			'AFN': {
				typeClass: 78,
				typeClassLiteral: 'AFN',
				it: "AFN",
				en: "AFN"
			},
			'LBP': {
				typeClass: 79,
				typeClassLiteral: 'LBP',
				it: "LBP",
				en: "LBP"
			},
			'XPF': {
				typeClass: 80,
				typeClassLiteral: 'XPF',
				it: "XPF",
				en: "XPF"
			},
			'TTD': {
				typeClass: 81,
				typeClassLiteral: 'TTD',
				it: "TTD",
				en: "TTD"
			},
			'TZS': {
				typeClass: 82,
				typeClassLiteral: 'TZS',
				it: "TZS",
				en: "TZS"
			},
			'ALL': {
				typeClass: 83,
				typeClassLiteral: 'ALL',
				it: "ALL",
				en: "ALL"
			},
			'XCD': {
				typeClass: 84,
				typeClassLiteral: 'XCD',
				it: "XCD",
				en: "XDC"
			},
			'GTQ': {
				typeClass: 85,
				typeClassLiteral: 'GTQ',
				it: "GTQ",
				en: "GTQ"
			},
			'NPR': {
				typeClass: 86,
				typeClassLiteral: 'NPR',
				it: "NPR",
				en: "NPR"
			},
			'BOB': {
				typeClass: 87,
				typeClassLiteral: 'BOB',
				it: "BOB",
				en: "BOB"
			},
			'ZWD': {
				typeClass: 88,
				typeClassLiteral: 'ZWD',
				it: "ZWS",
				en: "ZWD"
			},
			'BBD': {
				typeClass: 89,
				typeClassLiteral: 'BBD',
				it: "BBD",
				en: "BBD"
			},
			'CUC': {
				typeClass: 90,
				typeClassLiteral: 'CUC',
				it: "CUC",
				en: "CUC"
			},
			'LAK': {
				typeClass: 91,
				typeClassLiteral: 'LAK',
				it: "LAK",
				en: "LAK"
			},
			'BND': {
				typeClass: 92,
				typeClassLiteral: 'BND',
				it: "BND",
				en: "BND"
			},
			'BWP': {
				typeClass: 93,
				typeClassLiteral: 'BWP',
				it: "BWP",
				en: "BWP"
			},
			'HNL': {
				typeClass: 94,
				typeClassLiteral: 'HNL',
				it: "HNL",
				en: "HNL"
			},
			'PYG': {
				typeClass: 95,
				typeClassLiteral: 'PYG',
				it: "PYG",
				en: "PYG"
			},
			'ETB': {
				typeClass: 96,
				typeClassLiteral: 'ETB',
				it: "ETB",
				en: "ETB"
			},
			'NAD': {
				typeClass: 97,
				typeClassLiteral: 'NAD',
				it: "NAD",
				en: "NAD"
			},
			'PGK': {
				typeClass: 98,
				typeClassLiteral: 'PGK',
				it: "PGK",
				en: "PGK"
			},
			'SDG': {
				typeClass: 99,
				typeClassLiteral: 'SDG',
				it: "SDG",
				en: "SDG"
			},
			'MOP': {
				typeClass: 100,
				typeClassLiteral: 'MOP',
				it: "MOP",
				en: "MOP"
			},
			'NIO': {
				typeClass: 101,
				typeClassLiteral: 'NIO',
				it: "NIO",
				en: "NIO"
			},
			'BMD': {
				typeClass: 102,
				typeClassLiteral: 'BMD',
				it: "BMD",
				en: "BMD"
			},
			'KZT': {
				typeClass: 103,
				typeClassLiteral: 'KZT',
				it: "KZT",
				en: "KZT"
			},
			'PAB': {
				typeClass: 104,
				typeClassLiteral: 'PAB',
				it: "PAB",
				en: "PAB"
			},
			'BAM': {
				typeClass: 105,
				typeClassLiteral: 'BAM',
				it: "BAM",
				en: "BAM"
			},
			'GYD': {
				typeClass: 106,
				typeClassLiteral: 'GYD',
				it: "GYD",
				en: "GYD"
			},
			'YER': {
				typeClass: 107,
				typeClassLiteral: 'YER',
				it: "YER",
				en: "YER"
			},
			'MGA': {
				typeClass: 108,
				typeClassLiteral: 'MGA',
				it: "MGA",
				en: "MGA"
			},
			'KYD': {
				typeClass: 109,
				typeClassLiteral: 'KYD',
				it: "KYD",
				en: "KYD"
			},
			'MZN': {
				typeClass: 110,
				typeClassLiteral: 'MZN',
				it: "MZN",
				en: "MZN"
			},
			'RSD': {
				typeClass: 111,
				typeClassLiteral: 'RSD',
				it: "RSD",
				en: "RSD"
			},
			'SCR': {
				typeClass: 112,
				typeClassLiteral: 'SCR',
				it: "SCR",
				en: "SCR"
			},
			'AMD': {
				typeClass: 113,
				typeClassLiteral: 'AMD',
				it: "AMD",
				en: "AMD"
			},
			'SBD': {
				typeClass: 114,
				typeClassLiteral: 'SBD',
				it: "SBD",
				en: "SBD"
			},
			'AZN': {
				typeClass: 115,
				typeClassLiteral: 'AZN',
				it: "AZN",
				en: "AZN"
			},
			'SLL': {
				typeClass: 116,
				typeClassLiteral: 'SLL',
				it: "SLL",
				en: "SLL"
			},
			'TOP': {
				typeClass: 117,
				typeClassLiteral: 'TOP',
				it: "TOP",
				en: "TOP"
			},
			'BZD': {
				typeClass: 118,
				typeClassLiteral: 'BZD',
				it: "BZD",
				en: "BZD"
			},
			'MWK': {
				typeClass: 119,
				typeClassLiteral: 'MWK',
				it: "MWK",
				en: "MWK"
			},
			'GMD': {
				typeClass: 120,
				typeClassLiteral: 'GMD',
				it: "GMD",
				en: "GMD"
			},
			'BIF': {
				typeClass: 121,
				typeClassLiteral: 'BIF',
				it: "BIF",
				en: "BIF"
			},
			'SOS': {
				typeClass: 122,
				typeClassLiteral: 'SOS',
				it: "SOS",
				en: "SOS"
			},
			'HTG': {
				typeClass: 123,
				typeClassLiteral: 'HTG',
				it: "HTG",
				en: "HTG"
			},
			'GNF': {
				typeClass: 124,
				typeClassLiteral: 'GNF',
				it: "GNF",
				en: "GNF"
			},
			'MVR': {
				typeClass: 125,
				typeClassLiteral: 'MVR',
				it: "MVR",
				en: "MVR"
			},
			'MNT': {
				typeClass: 126,
				typeClassLiteral: 'MNT',
				it: "MNT",
				en: "MNT"
			},
			'CDF': {
				typeClass: 127,
				typeClassLiteral: 'CDF',
				it: "CDF",
				en: "CDF"
			},
			'STD': {
				typeClass: 128,
				typeClassLiteral: 'STD',
				it: "STD",
				en: "STD"
			},
			'TJS': {
				typeClass: 129,
				typeClassLiteral: 'TJS',
				it: "TJS",
				en: "TJS"
			},
			'KPW': {
				typeClass: 130,
				typeClassLiteral: 'KPW',
				it: "KPW",
				en: "KPW"
			},
			'MMK': {
				typeClass: 131,
				typeClassLiteral: 'MMK',
				it: "MMK",
				en: "MMK"
			},
			'LSL': {
				typeClass: 132,
				typeClassLiteral: 'LSL',
				it: "LSL",
				en: "LSL"
			},
			'LRD': {
				typeClass: 133,
				typeClassLiteral: 'LRD',
				it: "LRD",
				en: "LRD"
			},
			'KGS': {
				typeClass: 134,
				typeClassLiteral: 'KGS',
				it: "KGS",
				en: "KGS"
			},
			'GIP': {
				typeClass: 135,
				typeClassLiteral: 'GIP',
				it: "GIP",
				en: "GIP"
			},
			'XPT': {
				typeClass: 136,
				typeClassLiteral: 'XPT',
				it: "XPT",
				en: "XPT"
			},
			'MDL': {
				typeClass: 137,
				typeClassLiteral: 'MDL',
				it: "MDL",
				en: "MDL"
			},
			'CUP': {
				typeClass: 138,
				typeClassLiteral: 'CUP',
				it: "CUP",
				en: "CUP"
			},
			'KHR': {
				typeClass: 139,
				typeClassLiteral: 'KHR',
				it: "KHR",
				en: "KHR"
			},
			'MKD': {
				typeClass: 140,
				typeClassLiteral: 'MKD',
				it: "MKD",
				en: "MKD"
			},
			'VUV': {
				typeClass: 141,
				typeClassLiteral: 'VUV',
				it: "VUV",
				en: "VUV"
			},
			'MRO': {
				typeClass: 142,
				typeClassLiteral: 'MRO',
				it: "MRO",
				en: "MRO"
			},
			'ANG': {
				typeClass: 143,
				typeClassLiteral: 'ANG',
				it: "ANG",
				en: "ANG"
			},
			'SZL': {
				typeClass: 144,
				typeClassLiteral: 'SZL',
				it: "SZL",
				en: "SZL"
			},
			'CVE': {
				typeClass: 145,
				typeClassLiteral: 'CVE',
				it: "CVE",
				en: "CVE"
			},
			'SRD': {
				typeClass: 146,
				typeClassLiteral: 'SRD',
				it: "SRD",
				en: "SRD"
			},
			'XPD': {
				typeClass: 147,
				typeClassLiteral: 'XPD',
				it: "XPD",
				en: "XPD"
			},
			'SVC': {
				typeClass: 148,
				typeClassLiteral: 'SVC',
				it: "SVC",
				en: "SVC"
			},
			'BSD': {
				typeClass: 149,
				typeClassLiteral: 'BSD',
				it: "BSD",
				en: "BSD"
			},
			'XDR': {
				typeClass: 150,
				typeClassLiteral: 'XDR',
				it: "XDR",
				en: "XDR"
			},
			'RWF': {
				typeClass: 151,
				typeClassLiteral: 'RWF',
				it: "RWF",
				en: "RWF"
			},
			'AWG': {
				typeClass: 152,
				typeClassLiteral: 'AWG',
				it: "AWG",
				en: "AWG"
			},
			'DJF': {
				typeClass: 153,
				typeClassLiteral: 'DJF',
				it: "DJF",
				en: "DJF"
			},
			'BTN': {
				typeClass: 154,
				typeClassLiteral: 'BTN',
				it: "BTN",
				en: "BTN"
			},
			'KMF': {
				typeClass: 155,
				typeClassLiteral: 'KMF',
				it: "KMF",
				en: "KMF"
			},
			'WST': {
				typeClass: 156,
				typeClassLiteral: 'WST',
				it: "WST",
				en: "WST"
			},
			'SPL': {
				typeClass: 157,
				typeClassLiteral: 'SPL',
				it: "SPL",
				en: "SPL"
			},
			'ERN': {
				typeClass: 158,
				typeClassLiteral: 'ERN',
				it: "ERN",
				en: "ERN"
			},
			'FKP': {
				typeClass: 159,
				typeClassLiteral: 'FKP',
				it: "FKP",
				en: "FKP"
			},
			'SHP': {
				typeClass: 160,
				typeClassLiteral: 'SHP',
				it: "SHP",
				en: "SHP"
			},
			'JEP': {
				typeClass: 161,
				typeClassLiteral: 'JEP',
				it: "JEP",
				en: "JEP"
			},
			'TMT': {
				typeClass: 162,
				typeClassLiteral: 'TMT',
				it: "TMT",
				en: "TMT"
			},
			'TVD': {
				typeClass: 163,
				typeClassLiteral: 'TVD',
				it: "TVD",
				en: "TVD"
			},
			'IMP': {
				typeClass: 164,
				typeClassLiteral: 'IMP',
				it: "IMP",
				en: "IMP"
			},
			'GGP': {
				typeClass: 165,
				typeClassLiteral: 'GGP',
				it: "GGP",
				en: "GGP"
			},
			'ZMW': {
				typeClass: 166,
				typeClassLiteral: 'ZMW',
				it: "ZMW",
				en: "ZMW"
			}
		});
	},
	worldResourceType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'generic',
				it: "Generico",
				en: "Generic"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'vehicle',
				it: "Veicolo",
				en: "Vehicle"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'place',
				it: "Posto",
				en: "Place"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'table',
				it: "Tavolo",
				en: "Table"
			}
		});
	},
	worldLanguage() {
		return new TableClass({
			'it': {
				typeClass: 1,
				typeClassLiteral: 'it',
				it: "Italiano",
				en: "Italian"
			},
			'en': {
				typeClass: 2,
				typeClassLiteral: 'en',
				it: "Inglese",
				en: "English"
			}
		});
	},
	areaCode() {
		return new TableClass({
			'+39': {
				typeClass: 1,
				typeClassLiteral: '+39',
				it: "+39 (Italia)",
				en: "+39 (Italy)"
			},
			'+378': {
				typeClass: 2,
				typeClassLiteral: '+378',
				it: "+378 (San Marino)",
				en: "+378 (San Marino)"
			},
			'+1': {
				typeClass: 3,
				typeClassLiteral: '+1',
				it: "+1 (Stati Uniti d'America)",
				en: "+1 (United States)"
			},
			'+1': {
				typeClass: 4,
				typeClassLiteral: '+1',
				it: "+1 (Canada)",
				en: "+1 (Canada)"
			},
			'+1 340': {
				typeClass: 5,
				typeClassLiteral: '+1 340',
				it: "+1 340 (United States Virgin Island)",
				en: "+1 340 (United States Virgin Island)"
			},
			'+1 670': {
				typeClass: 6,
				typeClassLiteral: '+1 670',
				it: "+1 670 (Northern Mariana Islands)",
				en: "+1 670 (Northern Mariana Islands)"
			},
			'+1 671': {
				typeClass: 7,
				typeClassLiteral: '+1 671',
				it: "+1 671 (Guam)",
				en: "+1 671 (Guam)"
			},
			'+1 684': {
				typeClass: 8,
				typeClassLiteral: '+1 684',
				it: "+1 684 (American Samoa)",
				en: "+1 684 (American Samoa)"
			},
			'+1 787': {
				typeClass: 9,
				typeClassLiteral: '+1 787',
				it: "+1 787 (Puerto Rico)",
				en: "+1 787 (Puerto Rico)"
			},
			'+1 939': {
				typeClass: 10,
				typeClassLiteral: '+1 939',
				it: "+1 939 (Puerto Rico 2)",
				en: "+1 939 (Puerto Rico 2)"
			},
			'+1 242': {
				typeClass: 11,
				typeClassLiteral: '+1 242',
				it: "+1 242 (Bahamas)",
				en: "+1 242 (Bahamas)"
			},
			'+1 246': {
				typeClass: 12,
				typeClassLiteral: '+1 246',
				it: "+1 246 (Barbados)",
				en: "+1 246 (Barbados)"
			},
			'+1 264': {
				typeClass: 13,
				typeClassLiteral: '+1 264',
				it: "+1 264 (Anguilla)",
				en: "+1 264 (Anguilla)"
			},
			'+1 268': {
				typeClass: 14,
				typeClassLiteral: '+1 268',
				it: "+1 268 (Antigua)",
				en: "+1 268 (Antigua)"
			},
			'+1 268': {
				typeClass: 15,
				typeClassLiteral: '+1 268',
				it: "+1 268 (Barbuda)",
				en: "+1 268 (Barbuda)"
			},
			'+1 284': {
				typeClass: 16,
				typeClassLiteral: '+1 284',
				it: "+1 284 (British Virgin Islands)",
				en: "+1 284 (British Virgin Islands)"
			},
			'+1 345': {
				typeClass: 17,
				typeClassLiteral: '+1 345',
				it: "+1 345 (Cayman Islands)",
				en: "+1 345 (Cayman Islands)"
			},
			'+1 441': {
				typeClass: 18,
				typeClassLiteral: '+1 441',
				it: "+1 441 (Bermuda)",
				en: "+1 441 (Bermuda)"
			},
			'+1 473': {
				typeClass: 19,
				typeClassLiteral: '+1 473',
				it: "+1 473 (Grenada)",
				en: "+1 473 (Grenada)"
			},
			'+1 649': {
				typeClass: 20,
				typeClassLiteral: '+1 649',
				it: "+1 649 (Turks)",
				en: "+1 649 (Turks)"
			},
			'+1 649': {
				typeClass: 21,
				typeClassLiteral: '+1 649',
				it: "+1 649 (Caicos Islands)",
				en: "+1 649 (Caicos Islands)"
			},
			'+1 664': {
				typeClass: 22,
				typeClassLiteral: '+1 664',
				it: "+1 664 (Montserrat)",
				en: "+1 664 (Montserrat)"
			},
			'+1 721': {
				typeClass: 23,
				typeClassLiteral: '+1 721',
				it: "+1 721 (Sint Maarten)",
				en: "+1 721 (Sint Maarten)"
			},
			'+1 758': {
				typeClass: 24,
				typeClassLiteral: '+1 758',
				it: "+1 758 (Saint Lucia)",
				en: "+1 758 (Saint Lucia)"
			},
			'+1 767': {
				typeClass: 25,
				typeClassLiteral: '+1 767',
				it: "+1 767 (Dominica)",
				en: "+1 767 (Dominica)"
			},
			'+1 784': {
				typeClass: 26,
				typeClassLiteral: '+1 784',
				it: "+1 784 (Saint Vincent)",
				en: "+1 784 (Saint Vincent)"
			},
			'+1 784': {
				typeClass: 27,
				typeClassLiteral: '+1 784',
				it: "+1 784 (The Grenadines)",
				en: "+1 784 (The Grenadines)"
			},
			'+1 809': {
				typeClass: 28,
				typeClassLiteral: '+1 809',
				it: "+1 809 (Repubblica Dominicana)",
				en: "+1 809 (Dominican Republic)"
			},
			'+1 829': {
				typeClass: 29,
				typeClassLiteral: '+1 829',
				it: "+1 829 (Repubblica Dominicana 2)",
				en: "+1 829 (Dominican Republic 2)"
			},
			'+1 849': {
				typeClass: 30,
				typeClassLiteral: '+1 849',
				it: "+1 849 (Repubblica Dominicana 3)",
				en: "+1 849 (Dominican Republic 3)"
			},
			'+1 868': {
				typeClass: 31,
				typeClassLiteral: '+1 868',
				it: "+1 868 (Trinidad)",
				en: "+1 868 (Trinidad)"
			},
			'+1 868': {
				typeClass: 32,
				typeClassLiteral: '+1 868',
				it: "+1 868 (Tobago)",
				en: "+1 868 (Tobago)"
			},
			'+1 869': {
				typeClass: 33,
				typeClassLiteral: '+1 869',
				it: "+1 869 (Saint Kitts)",
				en: "+1 869 (Saint Kitts)"
			},
			'+1 869': {
				typeClass: 34,
				typeClassLiteral: '+1 869',
				it: "+1 869 (Nevis)",
				en: "+1 869 (Nevis)"
			},
			'+1 876': {
				typeClass: 35,
				typeClassLiteral: '+1 876',
				it: "+1 876 (Jamaica)",
				en: "+1 876 (Jamaica)"
			},
			'+1 658': {
				typeClass: 36,
				typeClassLiteral: '+1 658',
				it: "+1 658 (Jamaica 2)",
				en: "+1 658 (Jamaica 2)"
			},
			'+20': {
				typeClass: 37,
				typeClassLiteral: '+20',
				it: "+20 (Egitto)",
				en: "+20 (Egypt)"
			},
			'+211 ': {
				typeClass: 38,
				typeClassLiteral: '+211 ',
				it: "+211 (Sudan del Sud)",
				en: "+211 (South Sudan)"
			},
			'+212': {
				typeClass: 39,
				typeClassLiteral: '+212',
				it: "+212 (Marocco)",
				en: "+212 (Morocco)"
			},
			'+213': {
				typeClass: 40,
				typeClassLiteral: '+213',
				it: "+213 (Algeria)",
				en: "+213 (Algeria)"
			},
			'+216': {
				typeClass: 41,
				typeClassLiteral: '+216',
				it: "+216 (Tunisia)",
				en: "+216 (Tunisia)"
			},
			'+218': {
				typeClass: 42,
				typeClassLiteral: '+218',
				it: "+218 (Libia)",
				en: "+218 (Libya)"
			},
			'+220': {
				typeClass: 43,
				typeClassLiteral: '+220',
				it: "+220 (Gambia)",
				en: "+220 (Gambia)"
			},
			'+221': {
				typeClass: 44,
				typeClassLiteral: '+221',
				it: "+221 (Senegal)",
				en: "+221 (Senegal)"
			},
			'+222': {
				typeClass: 45,
				typeClassLiteral: '+222',
				it: "+222 (Mauritania)",
				en: "+222 (Mauritania)"
			},
			'+223': {
				typeClass: 46,
				typeClassLiteral: '+223',
				it: "+223 (Mali)",
				en: "+223 (Mali)"
			},
			'+224': {
				typeClass: 47,
				typeClassLiteral: '+224',
				it: "+224 (Guinea)",
				en: "+224 (Guinea)"
			},
			'+225': {
				typeClass: 48,
				typeClassLiteral: '+225',
				it: "+225 (Ivory Coast)",
				en: "+225 (Ivory Coast)"
			},
			'+226': {
				typeClass: 49,
				typeClassLiteral: '+226',
				it: "+226 (Burkina Faso)",
				en: "+226 (Burkina Faso)"
			},
			'+227': {
				typeClass: 50,
				typeClassLiteral: '+227',
				it: "+227 (Niger)",
				en: "+227 (Niger)"
			},
			'+228': {
				typeClass: 51,
				typeClassLiteral: '+228',
				it: "+228 (Togo)",
				en: "+228 (Togo)"
			},
			'+229': {
				typeClass: 52,
				typeClassLiteral: '+229',
				it: "+229 (Benin)",
				en: "+229 (Benin)"
			},
			'+230': {
				typeClass: 53,
				typeClassLiteral: '+230',
				it: "+230 (Mauritius)",
				en: "+230 (Mauritius)"
			},
			'+231': {
				typeClass: 54,
				typeClassLiteral: '+231',
				it: "+231 (Liberia)",
				en: "+231 (Liberia)"
			},
			'+232': {
				typeClass: 55,
				typeClassLiteral: '+232',
				it: "+232 (Sierra Leone)",
				en: "+232 (Sierra Leone)"
			},
			'+233': {
				typeClass: 56,
				typeClassLiteral: '+233',
				it: "+233 (Ghana)",
				en: "+233 (Ghana)"
			},
			'+234': {
				typeClass: 57,
				typeClassLiteral: '+234',
				it: "+234 (Nigeria)",
				en: "+234 (Nigeria)"
			},
			'+235': {
				typeClass: 58,
				typeClassLiteral: '+235',
				it: "+235 (Chad)",
				en: "+235 (Chad)"
			},
			'+236': {
				typeClass: 59,
				typeClassLiteral: '+236',
				it: "+236 (Repubblica Centrafricana)",
				en: "+236 (Central African Republic)"
			},
			'+237': {
				typeClass: 60,
				typeClassLiteral: '+237',
				it: "+237 (Cameroon)",
				en: "+237 (Cameroon)"
			},
			'+238': {
				typeClass: 61,
				typeClassLiteral: '+238',
				it: "+238 (Cape Verde)",
				en: "+238 (Cape Verde)"
			},
			'+239': {
				typeClass: 62,
				typeClassLiteral: '+239',
				it: "+239 (São Tomé)",
				en: "+239 (São Tomé)"
			},
			'+239': {
				typeClass: 63,
				typeClassLiteral: '+239',
				it: "+239 (Príncipe)",
				en: "+239 (Príncipe)"
			},
			'+240': {
				typeClass: 64,
				typeClassLiteral: '+240',
				it: "+240 (Guinea Equatoriale)",
				en: "+240 (Equatorial Guinea)"
			},
			'+241': {
				typeClass: 65,
				typeClassLiteral: '+241',
				it: "+241 (Gabon)",
				en: "+241 (Gabon)"
			},
			'+242': {
				typeClass: 66,
				typeClassLiteral: '+242',
				it: "+242 (Repubblica del Congo)",
				en: "+242 (Republic of the Congo)"
			},
			'+243': {
				typeClass: 67,
				typeClassLiteral: '+243',
				it: "+243 (Repubblica Democratica del Congo)",
				en: "+243 (Democratic Republic of the Congo)"
			},
			'+244': {
				typeClass: 68,
				typeClassLiteral: '+244',
				it: "+244 (Angola)",
				en: "+244 (Angola)"
			},
			'+245': {
				typeClass: 69,
				typeClassLiteral: '+245',
				it: "+245 (Guinea-Bissau)",
				en: "+245 (Guinea-Bissau)"
			},
			'+246': {
				typeClass: 70,
				typeClassLiteral: '+246',
				it: "+246 (Territorio britannico dell'Oceano Indiano)",
				en: "+246 (British Indian Ocean Territory)"
			},
			'+247': {
				typeClass: 71,
				typeClassLiteral: '+247',
				it: "+247 (Ascension Island)",
				en: "+247 (Ascension Island)"
			},
			'+248': {
				typeClass: 72,
				typeClassLiteral: '+248',
				it: "+248 (Seychelles)",
				en: "+248 (Seychelles)"
			},
			'+249': {
				typeClass: 73,
				typeClassLiteral: '+249',
				it: "+249 (Sudan)",
				en: "+249 (Sudan)"
			},
			'+250': {
				typeClass: 74,
				typeClassLiteral: '+250',
				it: "+250 (Rwanda)",
				en: "+250 (Rwanda)"
			},
			'+251': {
				typeClass: 75,
				typeClassLiteral: '+251',
				it: "+251 (Etiopia)",
				en: "+251 (Ethiopia)"
			},
			'+252': {
				typeClass: 76,
				typeClassLiteral: '+252',
				it: "+252 (Somalia)",
				en: "+252 (Somalia)"
			},
			'+253': {
				typeClass: 77,
				typeClassLiteral: '+253',
				it: "+253 (Djibouti)",
				en: "+253 (Djibouti)"
			},
			'+254': {
				typeClass: 78,
				typeClassLiteral: '+254',
				it: "+254 (Kenya)",
				en: "+254 (Kenya)"
			},
			'+255': {
				typeClass: 79,
				typeClassLiteral: '+255',
				it: "+255 (Tanzania)",
				en: "+255 (Tanzania)"
			},
			'+255 24': {
				typeClass: 80,
				typeClassLiteral: '+255 24',
				it: "+255 24 (Zanzibar)",
				en: "+255 24 (Zanzibar)"
			},
			'+256': {
				typeClass: 81,
				typeClassLiteral: '+256',
				it: "+256 (Uganda)",
				en: "+256 (Uganda)"
			},
			'+257': {
				typeClass: 82,
				typeClassLiteral: '+257',
				it: "+257 (Burundi)",
				en: "+257 (Burundi)"
			},
			'+258': {
				typeClass: 83,
				typeClassLiteral: '+258',
				it: "+258 (Mozambico)",
				en: "+258 (Mozambique)"
			},
			'+260': {
				typeClass: 84,
				typeClassLiteral: '+260',
				it: "+260 (Zambia)",
				en: "+260 (Zambia)"
			},
			'+261': {
				typeClass: 85,
				typeClassLiteral: '+261',
				it: "+261 (Madagascar)",
				en: "+261 (Madagascar)"
			},
			'+262': {
				typeClass: 86,
				typeClassLiteral: '+262',
				it: "+262 (R�union)",
				en: "+262 (R�union)"
			},
			'+263': {
				typeClass: 87,
				typeClassLiteral: '+263',
				it: "+263 (Zimbabwe)",
				en: "+263 (Zimbabwe)"
			},
			'+264': {
				typeClass: 88,
				typeClassLiteral: '+264',
				it: "+264 (Namibia)",
				en: "+264 (Namibia)"
			},
			'+265': {
				typeClass: 89,
				typeClassLiteral: '+265',
				it: "+265 (Malawi)",
				en: "+265 (Malawi)"
			},
			'+266': {
				typeClass: 90,
				typeClassLiteral: '+266',
				it: "+266 (Lesotho)",
				en: "+266 (Lesotho)"
			},
			'+267': {
				typeClass: 91,
				typeClassLiteral: '+267',
				it: "+267 (Botswana)",
				en: "+267 (Botswana)"
			},
			'+268': {
				typeClass: 92,
				typeClassLiteral: '+268',
				it: "+268 (Eswatini)",
				en: "+268 (Eswatini)"
			},
			'+269': {
				typeClass: 93,
				typeClassLiteral: '+269',
				it: "+269 (Comoros)",
				en: "+269 (Comoros)"
			},
			'+27': {
				typeClass: 94,
				typeClassLiteral: '+27',
				it: "+27 (Sud Africa)",
				en: "+27 (South Africa)"
			},
			'+290': {
				typeClass: 95,
				typeClassLiteral: '+290',
				it: "+290 (Saint Helena)",
				en: "+290 (Saint Helena)"
			},
			'+290 8': {
				typeClass: 96,
				typeClassLiteral: '+290 8',
				it: "+290 8 (Tristan da Cunha)",
				en: "+290 8 (Tristan da Cunha)"
			},
			'+291': {
				typeClass: 97,
				typeClassLiteral: '+291',
				it: "+291 (Eritrea)",
				en: "+291 (Eritrea)"
			},
			'+297': {
				typeClass: 98,
				typeClassLiteral: '+297',
				it: "+297 (Aruba)",
				en: "+297 (Aruba)"
			},
			'+298': {
				typeClass: 99,
				typeClassLiteral: '+298',
				it: "+298 (Faroe Islands)",
				en: "+298 (Faroe Islands)"
			},
			'+299': {
				typeClass: 100,
				typeClassLiteral: '+299',
				it: "+299 (Greenland)",
				en: "+299 (Greenland)"
			},
			'+30': {
				typeClass: 101,
				typeClassLiteral: '+30',
				it: "+30 (Grecia)",
				en: "+30 (Greece)"
			},
			'+31': {
				typeClass: 102,
				typeClassLiteral: '+31',
				it: "+31 (Olanda)",
				en: "+31 (Netherlands)"
			},
			'+32': {
				typeClass: 103,
				typeClassLiteral: '+32',
				it: "+32 (Belgio)",
				en: "+32 (Belgium)"
			},
			'+33': {
				typeClass: 104,
				typeClassLiteral: '+33',
				it: "+33 (Francia)",
				en: "+33 (France)"
			},
			'+34': {
				typeClass: 105,
				typeClassLiteral: '+34',
				it: "+34 (Spagna)",
				en: "+34 (Spain)"
			},
			'+350': {
				typeClass: 106,
				typeClassLiteral: '+350',
				it: "+350 (Gibilterra)",
				en: "+350 (Gibraltar)"
			},
			'+351': {
				typeClass: 107,
				typeClassLiteral: '+351',
				it: "+351 (Portogallo)",
				en: "+351 (Portugal)"
			},
			'+352': {
				typeClass: 108,
				typeClassLiteral: '+352',
				it: "+352 (Lussemburgo)",
				en: "+352 (Luxembourg)"
			},
			'+353': {
				typeClass: 109,
				typeClassLiteral: '+353',
				it: "+353 (Irlanda)",
				en: "+353 (Ireland)"
			},
			'+354': {
				typeClass: 110,
				typeClassLiteral: '+354',
				it: "+354 (Islanda)",
				en: "+354 (Iceland)"
			},
			'+355': {
				typeClass: 111,
				typeClassLiteral: '+355',
				it: "+355 (Albania)",
				en: "+355 (Albania)"
			},
			'+356': {
				typeClass: 112,
				typeClassLiteral: '+356',
				it: "+356 (Malta)",
				en: "+356 (Malta)"
			},
			'+357': {
				typeClass: 113,
				typeClassLiteral: '+357',
				it: "+357 (Cipro)",
				en: "+357 (Cyprus)"
			},
			'+358': {
				typeClass: 114,
				typeClassLiteral: '+358',
				it: "+358 (Finlandia)",
				en: "+358 (Finland)"
			},
			'+358 18': {
				typeClass: 115,
				typeClassLiteral: '+358 18',
				it: "+358 18 (Aland Islands)",
				en: "+358 18 (Aland Islands)"
			},
			'+359': {
				typeClass: 116,
				typeClassLiteral: '+359',
				it: "+359 (Bulgaria)",
				en: "+359 (Bulgaria)"
			},
			'+36': {
				typeClass: 117,
				typeClassLiteral: '+36',
				it: "+36 (Ungheria)",
				en: "+36 (Hungary )"
			},
			'+370': {
				typeClass: 118,
				typeClassLiteral: '+370',
				it: "+370 (Lituania)",
				en: "+370 (Lithuania)"
			},
			'+371': {
				typeClass: 119,
				typeClassLiteral: '+371',
				it: "+371 (Lettonia)",
				en: "+371 (Latvia )"
			},
			'+372': {
				typeClass: 120,
				typeClassLiteral: '+372',
				it: "+372 (Estonia)",
				en: "+372 (Estonia)"
			},
			'+373': {
				typeClass: 121,
				typeClassLiteral: '+373',
				it: "+373 (Moldova)",
				en: "+373 (Moldova)"
			},
			'+374': {
				typeClass: 122,
				typeClassLiteral: '+374',
				it: "+374 (Armenia)",
				en: "+374 (Armenia)"
			},
			'+374 47': {
				typeClass: 123,
				typeClassLiteral: '+374 47',
				it: "+374 47 (Artsakh)",
				en: "+374 47 (Artsakh)"
			},
			'+374 97': {
				typeClass: 124,
				typeClassLiteral: '+374 97',
				it: "+374 97 (Artsakh2)",
				en: "+374 97 (Artsakh2)"
			},
			'+375': {
				typeClass: 125,
				typeClassLiteral: '+375',
				it: "+375 (Bielorussia)",
				en: "+375 (Belarus)"
			},
			'+376': {
				typeClass: 126,
				typeClassLiteral: '+376',
				it: "+376 (Andorra)",
				en: "+376 (Andorra)"
			},
			'+377': {
				typeClass: 127,
				typeClassLiteral: '+377',
				it: "+377 (Monaco)",
				en: "+377 (Monaco)"
			},
			'+379': {
				typeClass: 128,
				typeClassLiteral: '+379',
				it: "+379 (Città del Vaticano)",
				en: "+379 (Vatican City)"
			},
			'+380': {
				typeClass: 129,
				typeClassLiteral: '+380',
				it: "+380 (Ucraina)",
				en: "+380 (Ukraine)"
			},
			'+381': {
				typeClass: 130,
				typeClassLiteral: '+381',
				it: "+381 (Serbia)",
				en: "+381 (Serbia)"
			},
			'+382': {
				typeClass: 131,
				typeClassLiteral: '+382',
				it: "+382 (Montenegro)",
				en: "+382 (Montenegro)"
			},
			'+383': {
				typeClass: 132,
				typeClassLiteral: '+383',
				it: "+383 (Kosovo)",
				en: "+383 (Kosovo)"
			},
			'+385': {
				typeClass: 133,
				typeClassLiteral: '+385',
				it: "+385 (Croazia)",
				en: "+385 (Croatia)"
			},
			'+386': {
				typeClass: 134,
				typeClassLiteral: '+386',
				it: "+386 (Slovenia)",
				en: "+386 (Slovenia)"
			},
			'+387': {
				typeClass: 135,
				typeClassLiteral: '+387',
				it: "+387 (Bosnia)",
				en: "+387 (Bosnia)"
			},
			'+387': {
				typeClass: 136,
				typeClassLiteral: '+387',
				it: "+387 (Herzegovina)",
				en: "+387 (Herzegovina)"
			},
			'+389': {
				typeClass: 137,
				typeClassLiteral: '+389',
				it: "+389 (Macedonia Settentrionale)",
				en: "+389 (North Macedonia)"
			},
			'+40': {
				typeClass: 138,
				typeClassLiteral: '+40',
				it: "+40 (Romania)",
				en: "+40 (Romania)"
			},
			'+41': {
				typeClass: 139,
				typeClassLiteral: '+41',
				it: "+41 (Svizzera)",
				en: "+41 (Switzerland)"
			},
			'+420': {
				typeClass: 140,
				typeClassLiteral: '+420',
				it: "+420 (Repubblica Ceca)",
				en: "+420 (Czech Republic)"
			},
			'+421': {
				typeClass: 141,
				typeClassLiteral: '+421',
				it: "+421 (Slovacchia)",
				en: "+421 (Slovakia)"
			},
			'+423': {
				typeClass: 142,
				typeClassLiteral: '+423',
				it: "+423 (Liechtenstein )",
				en: "+423 (Liechtenstein )"
			},
			'+43': {
				typeClass: 143,
				typeClassLiteral: '+43',
				it: "+43 (Austria)",
				en: "+43 (Austria)"
			},
			'+44': {
				typeClass: 144,
				typeClassLiteral: '+44',
				it: "+44 (Regno Unito)",
				en: "+44 (United Kingdom)"
			},
			'+44 1481': {
				typeClass: 145,
				typeClassLiteral: '+44 1481',
				it: "+44 1481 (Guernsey)",
				en: "+44 1481 (Guernsey)"
			},
			'+44 1534': {
				typeClass: 146,
				typeClassLiteral: '+44 1534',
				it: "+44 1534 (Jersey)",
				en: "+44 1534 (Jersey)"
			},
			'+44 1624': {
				typeClass: 147,
				typeClassLiteral: '+44 1624',
				it: "+44 1624 (Isle of Man)",
				en: "+44 1624 (Isle of Man)"
			},
			'+45': {
				typeClass: 148,
				typeClassLiteral: '+45',
				it: "+45 (Danimarca)",
				en: "+45 (Denmark)"
			},
			'+46': {
				typeClass: 149,
				typeClassLiteral: '+46',
				it: "+46 (Svezia)",
				en: "+46 (Sweden)"
			},
			'+47': {
				typeClass: 150,
				typeClassLiteral: '+47',
				it: "+47 (Norvegia)",
				en: "+47 (Norway)"
			},
			'+47 79': {
				typeClass: 151,
				typeClassLiteral: '+47 79',
				it: "+47 79 (Svalbard)",
				en: "+47 79 (Svalbard)"
			},
			'+48': {
				typeClass: 152,
				typeClassLiteral: '+48',
				it: "+48 (Polonia)",
				en: "+48 (Poland)"
			},
			'+49': {
				typeClass: 153,
				typeClassLiteral: '+49',
				it: "+49 (Germania)",
				en: "+49 (Germany)"
			},
			'+500': {
				typeClass: 154,
				typeClassLiteral: '+500',
				it: "+500 (Falkland Islands)",
				en: "+500 (Falkland Islands)"
			},
			'+501': {
				typeClass: 155,
				typeClassLiteral: '+501',
				it: "+501 (Belize)",
				en: "+501 (Belize)"
			},
			'+502': {
				typeClass: 156,
				typeClassLiteral: '+502',
				it: "+502 (Guatemala)",
				en: "+502 (Guatemala)"
			},
			'+503': {
				typeClass: 157,
				typeClassLiteral: '+503',
				it: "+503 (El Salvador)",
				en: "+503 (El Salvador)"
			},
			'+504': {
				typeClass: 158,
				typeClassLiteral: '+504',
				it: "+504 (Honduras)",
				en: "+504 (Honduras)"
			},
			'+505': {
				typeClass: 159,
				typeClassLiteral: '+505',
				it: "+505 (Nicaragua)",
				en: "+505 (Nicaragua)"
			},
			'+506': {
				typeClass: 160,
				typeClassLiteral: '+506',
				it: "+506 (Costa Rica)",
				en: "+506 (Costa Rica)"
			},
			'+507': {
				typeClass: 161,
				typeClassLiteral: '+507',
				it: "+507 (Panama)",
				en: "+507 (Panama)"
			},
			'+508': {
				typeClass: 162,
				typeClassLiteral: '+508',
				it: "+508 (Saint-Pierre)",
				en: "+508 (Saint-Pierre)"
			},
			'+508': {
				typeClass: 163,
				typeClassLiteral: '+508',
				it: "+508 (Miquelon)",
				en: "+508 (Miquelon)"
			},
			'+509': {
				typeClass: 164,
				typeClassLiteral: '+509',
				it: "+509 (Haiti)",
				en: "+509 (Haiti)"
			},
			'+51': {
				typeClass: 165,
				typeClassLiteral: '+51',
				it: "+51 (Peru)",
				en: "+51 (Peru)"
			},
			'+52': {
				typeClass: 166,
				typeClassLiteral: '+52',
				it: "+52 (Mexico)",
				en: "+52 (Mexico)"
			},
			'+53': {
				typeClass: 167,
				typeClassLiteral: '+53',
				it: "+53 (Cuba)",
				en: "+53 (Cuba)"
			},
			'+54': {
				typeClass: 168,
				typeClassLiteral: '+54',
				it: "+54 (Argentina)",
				en: "+54 (Argentina)"
			},
			'+55': {
				typeClass: 169,
				typeClassLiteral: '+55',
				it: "+55 (Brasile)",
				en: "+55 (Brazil)"
			},
			'+56': {
				typeClass: 170,
				typeClassLiteral: '+56',
				it: "+56 (Chile)",
				en: "+56 (Chile)"
			},
			'+57': {
				typeClass: 171,
				typeClassLiteral: '+57',
				it: "+57 (Columbia)",
				en: "+57 (Columbia)"
			},
			'+58': {
				typeClass: 172,
				typeClassLiteral: '+58',
				it: "+58 (Venezuela)",
				en: "+58 (Venezuela)"
			},
			'+590': {
				typeClass: 173,
				typeClassLiteral: '+590',
				it: "+590 (Guadeloupe)",
				en: "+590 (Guadeloupe)"
			},
			'+590': {
				typeClass: 174,
				typeClassLiteral: '+590',
				it: "+590 (Saint-Barthélemy)",
				en: "+590 (Saint-Barthélemy)"
			},
			'+590': {
				typeClass: 175,
				typeClassLiteral: '+590',
				it: "+590 (Saint Martin)",
				en: "+590 (Saint Martin)"
			},
			'+591': {
				typeClass: 176,
				typeClassLiteral: '+591',
				it: "+591 (Bolivia)",
				en: "+591 (Bolivia)"
			},
			'+592': {
				typeClass: 177,
				typeClassLiteral: '+592',
				it: "+592 (Guyana)",
				en: "+592 (Guyana)"
			},
			'+593': {
				typeClass: 178,
				typeClassLiteral: '+593',
				it: "+593 (Ecuador)",
				en: "+593 (Ecuador)"
			},
			'+594': {
				typeClass: 179,
				typeClassLiteral: '+594',
				it: "+594 (French Guiana)",
				en: "+594 (French Guiana)"
			},
			'+595': {
				typeClass: 180,
				typeClassLiteral: '+595',
				it: "+595 (Paraguay)",
				en: "+595 (Paraguay)"
			},
			'+596': {
				typeClass: 181,
				typeClassLiteral: '+596',
				it: "+596 (Martinique)",
				en: "+596 (Martinique)"
			},
			'+597': {
				typeClass: 182,
				typeClassLiteral: '+597',
				it: "+597 (Suriname)",
				en: "+597 (Suriname)"
			},
			'+598': {
				typeClass: 183,
				typeClassLiteral: '+598',
				it: "+598 (Uruguay)",
				en: "+598 (Uruguay)"
			},
			'+599': {
				typeClass: 184,
				typeClassLiteral: '+599',
				it: "+599 (Antille Olandesi)",
				en: "+599 (Netherlands Antilles)"
			},
			'+599 3': {
				typeClass: 185,
				typeClassLiteral: '+599 3',
				it: "+599 3 (Sint Eustatius)",
				en: "+599 3 (Sint Eustatius)"
			},
			'+599 4': {
				typeClass: 186,
				typeClassLiteral: '+599 4',
				it: "+599 4 (Saba)",
				en: "+599 4 (Saba)"
			},
			'+599 7': {
				typeClass: 187,
				typeClassLiteral: '+599 7',
				it: "+599 7 (Bonaire)",
				en: "+599 7 (Bonaire)"
			},
			'+599 9': {
				typeClass: 188,
				typeClassLiteral: '+599 9',
				it: "+599 9 (Curaçao)",
				en: "+599 9 (Curaçao)"
			},
			'+60': {
				typeClass: 189,
				typeClassLiteral: '+60',
				it: "+60 (Malaysia)",
				en: "+60 (Malaysia)"
			},
			'+61': {
				typeClass: 190,
				typeClassLiteral: '+61',
				it: "+61 (Australia)",
				en: "+61 (Australia)"
			},
			'+61 8 9162': {
				typeClass: 191,
				typeClassLiteral: '+61 8 9162',
				it: "+6 8 9162 (Cocos Islands)",
				en: "+6 8 9162 (Cocos Islands)"
			},
			'+61 8 9164': {
				typeClass: 192,
				typeClassLiteral: '+61 8 9164',
				it: "+61 8 9164 (Christmas Island)",
				en: "+61 8 9164 (Christmas Island)"
			},
			'+62': {
				typeClass: 193,
				typeClassLiteral: '+62',
				it: "+62 (Indonesia)",
				en: "+62 (Indonesia)"
			},
			'+63': {
				typeClass: 194,
				typeClassLiteral: '+63',
				it: "+63 (Filippine)",
				en: "+63 (Philippines)"
			},
			'+64': {
				typeClass: 195,
				typeClassLiteral: '+64',
				it: "+64 (Nuova Zelanda)",
				en: "+64 (New Zealand)"
			},
			'+64': {
				typeClass: 196,
				typeClassLiteral: '+64',
				it: "+64 (Pitcairn Islands)",
				en: "+64 (Pitcairn Islands)"
			},
			'+65': {
				typeClass: 197,
				typeClassLiteral: '+65',
				it: "+65 (Singapore)",
				en: "+65 (Singapore)"
			},
			'+66': {
				typeClass: 198,
				typeClassLiteral: '+66',
				it: "+66 (Tailandia)",
				en: "+66 (Thailand)"
			},
			'+670': {
				typeClass: 199,
				typeClassLiteral: '+670',
				it: "+670 (East Timor)",
				en: "+670 (East Timor)"
			},
			'+672 1': {
				typeClass: 200,
				typeClassLiteral: '+672 1',
				it: "+672 1 (Australian Antarctic Territory)",
				en: "+672 1 (Australian Antarctic Territory)"
			},
			'+672 3': {
				typeClass: 201,
				typeClassLiteral: '+672 3',
				it: "+672 3 (Norfolk Island)",
				en: "+672 3 (Norfolk Island)"
			},
			'+673': {
				typeClass: 202,
				typeClassLiteral: '+673',
				it: "+673 (Brunei)",
				en: "+673 (Brunei)"
			},
			'+674': {
				typeClass: 203,
				typeClassLiteral: '+674',
				it: "+674 (Nauru)",
				en: "+674 (Nauru)"
			},
			'+675': {
				typeClass: 204,
				typeClassLiteral: '+675',
				it: "+675 (Papua Nuova Guinea)",
				en: "+675 (Papua New Guinea)"
			},
			'+676': {
				typeClass: 205,
				typeClassLiteral: '+676',
				it: "+676 (Tonga)",
				en: "+676 (Tonga)"
			},
			'+677': {
				typeClass: 206,
				typeClassLiteral: '+677',
				it: "+677 (Solomon Islands)",
				en: "+677 (Solomon Islands)"
			},
			'+678': {
				typeClass: 207,
				typeClassLiteral: '+678',
				it: "+678 (Vanuatu)",
				en: "+678 (Vanuatu)"
			},
			'+679': {
				typeClass: 208,
				typeClassLiteral: '+679',
				it: "+679 (Fiji)",
				en: "+679 (Fiji)"
			},
			'+680': {
				typeClass: 209,
				typeClassLiteral: '+680',
				it: "+680 (Palau)",
				en: "+680 (Palau)"
			},
			'+681': {
				typeClass: 210,
				typeClassLiteral: '+681',
				it: "+681 (Wallis)",
				en: "+681 (Wallis)"
			},
			'+681': {
				typeClass: 211,
				typeClassLiteral: '+681',
				it: "+681 (Futuna)",
				en: "+681 (Futuna)"
			},
			'+682': {
				typeClass: 212,
				typeClassLiteral: '+682',
				it: "+682 (Cook Islands)",
				en: "+682 (Cook Islands)"
			},
			'+683': {
				typeClass: 213,
				typeClassLiteral: '+683',
				it: "+683 (Niue)",
				en: "+683 (Niue)"
			},
			'+685': {
				typeClass: 214,
				typeClassLiteral: '+685',
				it: "+685 (Samoa)",
				en: "+685 (Samoa)"
			},
			'+686': {
				typeClass: 215,
				typeClassLiteral: '+686',
				it: "+686 (Kiribati)",
				en: "+686 (Kiribati)"
			},
			'+687': {
				typeClass: 216,
				typeClassLiteral: '+687',
				it: "+687 (New Caledonia)",
				en: "+687 (New Caledonia)"
			},
			'+688': {
				typeClass: 217,
				typeClassLiteral: '+688',
				it: "+688 (Tuvalu)",
				en: "+688 (Tuvalu)"
			},
			'+689': {
				typeClass: 218,
				typeClassLiteral: '+689',
				it: "+689 (Polinesia Francese)",
				en: "+689 (French Polynesia)"
			},
			'+690': {
				typeClass: 219,
				typeClassLiteral: '+690',
				it: "+690 (Tokelau)",
				en: "+690 (Tokelau)"
			},
			'+691': {
				typeClass: 220,
				typeClassLiteral: '+691',
				it: "+691 (Federated States of Micronesia)",
				en: "+691 (Federated States of Micronesia)"
			},
			'+692': {
				typeClass: 221,
				typeClassLiteral: '+692',
				it: "+692 (Marshall Islands)",
				en: "+692 (Marshall Islands)"
			},
			'+7': {
				typeClass: 222,
				typeClassLiteral: '+7',
				it: "+7 (Russia)",
				en: "+7 (Russia)"
			},
			'+7 6': {
				typeClass: 223,
				typeClassLiteral: '+7 6',
				it: "+7 6 (Kazakhstan)",
				en: "+7 6 (Kazakhstan)"
			},
			'+7 840': {
				typeClass: 224,
				typeClassLiteral: '+7 840',
				it: "+7 840 (Abkhazia)",
				en: "+7 840 (Abkhazia)"
			},
			'+81': {
				typeClass: 225,
				typeClassLiteral: '+81',
				it: "+81 (Giappone)",
				en: "+81 (Japan)"
			},
			'+82': {
				typeClass: 226,
				typeClassLiteral: '+82',
				it: "+82 (Corea del Sud)",
				en: "+82 (South Korea)"
			},
			'+84': {
				typeClass: 227,
				typeClassLiteral: '+84',
				it: "+84 (Vietnam)",
				en: "+84 (Vietnam)"
			},
			'+850': {
				typeClass: 228,
				typeClassLiteral: '+850',
				it: "+850 (Corea del Nord)",
				en: "+850 (North Korea)"
			},
			'+852': {
				typeClass: 229,
				typeClassLiteral: '+852',
				it: "+852 (Hong Kong)",
				en: "+852 (Hong Kong)"
			},
			'+853': {
				typeClass: 230,
				typeClassLiteral: '+853',
				it: "+853 (Macau)",
				en: "+853 (Macau)"
			},
			'+855': {
				typeClass: 231,
				typeClassLiteral: '+855',
				it: "+855 (Cambogia)",
				en: "+855 (Cambodia)"
			},
			'+856': {
				typeClass: 232,
				typeClassLiteral: '+856',
				it: "+856 (Laos)",
				en: "+856 (Laos)"
			},
			'+86': {
				typeClass: 233,
				typeClassLiteral: '+86',
				it: "+86 (Cina)",
				en: "+86 (China)"
			},
			'+880': {
				typeClass: 234,
				typeClassLiteral: '+880',
				it: "+880 (Bangladesh)",
				en: "+880 (Bangladesh)"
			},
			'+886': {
				typeClass: 235,
				typeClassLiteral: '+886',
				it: "+886 (Taiwan)",
				en: "+886 (Taiwan)"
			},
			'+90': {
				typeClass: 236,
				typeClassLiteral: '+90',
				it: "+90 (Turchia)",
				en: "+90 (Turkey)"
			},
			'+90 392': {
				typeClass: 237,
				typeClassLiteral: '+90 392',
				it: "+90 392 (Cipro del Nord)",
				en: "+90 392 (Northern Cyprus)"
			},
			'+91': {
				typeClass: 238,
				typeClassLiteral: '+91',
				it: "+91 (India)",
				en: "+91 (India)"
			},
			'+92': {
				typeClass: 239,
				typeClassLiteral: '+92',
				it: "+92 (Pakistan)",
				en: "+92 (Pakistan)"
			},
			'+92 582': {
				typeClass: 240,
				typeClassLiteral: '+92 582',
				it: "+92 582 (Azad Kashmir)",
				en: "+92 582 (Azad Kashmir)"
			},
			'+92 581': {
				typeClass: 241,
				typeClassLiteral: '+92 581',
				it: "+92 581 (Gilgit Baltistan)",
				en: "+92 581 (Gilgit Baltistan)"
			},
			'+93': {
				typeClass: 242,
				typeClassLiteral: '+93',
				it: "+93 (Afghanistan)",
				en: "+93 (Afghanistan)"
			},
			'+94': {
				typeClass: 243,
				typeClassLiteral: '+94',
				it: "+94 (Sri Lanka)",
				en: "+94 (Sri Lanka)"
			},
			'+95': {
				typeClass: 244,
				typeClassLiteral: '+95',
				it: "+95 (Myanmar)",
				en: "+95 (Myanmar)"
			},
			'+960': {
				typeClass: 245,
				typeClassLiteral: '+960',
				it: "+960 (Maldive)",
				en: "+960 (Maldives)"
			},
			'+961': {
				typeClass: 246,
				typeClassLiteral: '+961',
				it: "+961 (Lebanon)",
				en: "+961 (Lebanon)"
			},
			'+962': {
				typeClass: 247,
				typeClassLiteral: '+962',
				it: "+962 (Jordan)",
				en: "+962 (Jordan)"
			},
			'+963': {
				typeClass: 248,
				typeClassLiteral: '+963',
				it: "+963 (Siria)",
				en: "+963 (Syria)"
			},
			'+964': {
				typeClass: 249,
				typeClassLiteral: '+964',
				it: "+964 (Iraq)",
				en: "+964 (Iraq)"
			},
			'+965': {
				typeClass: 250,
				typeClassLiteral: '+965',
				it: "+965 (Kuwait)",
				en: "+965 (Kuwait)"
			},
			'+966': {
				typeClass: 251,
				typeClassLiteral: '+966',
				it: "+966 (Arabia Saudita)",
				en: "+966 (Saudi Arabia)"
			},
			'+967': {
				typeClass: 252,
				typeClassLiteral: '+967',
				it: "+967 (Yemen)",
				en: "+967 (Yemen)"
			},
			'+968': {
				typeClass: 253,
				typeClassLiteral: '+968',
				it: "+968 (Oman)",
				en: "+968 (Oman)"
			},
			'+970': {
				typeClass: 254,
				typeClassLiteral: '+970',
				it: "+970 (Palestina)",
				en: "+970 (Palestine)"
			},
			'+971': {
				typeClass: 255,
				typeClassLiteral: '+971',
				it: "+971 (Emirati Arabi Uniti)",
				en: "+971 (United Arab Emirates)"
			},
			'+972': {
				typeClass: 256,
				typeClassLiteral: '+972',
				it: "+972 (Israele)",
				en: "+972 (Israel)"
			},
			'+973': {
				typeClass: 257,
				typeClassLiteral: '+973',
				it: "+973 (Bahrain)",
				en: "+973 (Bahrain)"
			},
			'+974': {
				typeClass: 258,
				typeClassLiteral: '+974',
				it: "+974 (Qatar)",
				en: "+974 (Qatar)"
			},
			'+975': {
				typeClass: 259,
				typeClassLiteral: '+975',
				it: "+975 (Bhutan)",
				en: "+975 (Bhutan)"
			},
			'+976': {
				typeClass: 260,
				typeClassLiteral: '+976',
				it: "+976 (Mongolia)",
				en: "+976 (Mongolia)"
			},
			'+977': {
				typeClass: 261,
				typeClassLiteral: '+977',
				it: "+977 (Nepal)",
				en: "+977 (Nepal)"
			},
			'+98': {
				typeClass: 262,
				typeClassLiteral: '+98',
				it: "+98 (Iran)",
				en: "+98 (Iran)"
			},
			'+992': {
				typeClass: 263,
				typeClassLiteral: '+992',
				it: "+992 (Tajikistan)",
				en: "+992 (Tajikistan)"
			},
			'+993': {
				typeClass: 264,
				typeClassLiteral: '+993',
				it: "+993 (Turkmenistan)",
				en: "+993 (Turkmenistan)"
			},
			'+994': {
				typeClass: 265,
				typeClassLiteral: '+994',
				it: "+994 (Azerbaijan)",
				en: "+994 (Azerbaijan)"
			},
			'+995': {
				typeClass: 266,
				typeClassLiteral: '+995',
				it: "+995 (Georgia)",
				en: "+995 (Georgia)"
			},
			'+995 34': {
				typeClass: 267,
				typeClassLiteral: '+995 34',
				it: "+995 34 (South Ossetia)",
				en: "+995 34 (South Ossetia)"
			},
			'+996': {
				typeClass: 268,
				typeClassLiteral: '+996',
				it: "+996 (Kyrgyzstan)",
				en: "+996 (Kyrgyzstan)"
			},
			'+998': {
				typeClass: 269,
				typeClassLiteral: '+998',
				it: "+998 (Uzbekistan)",
				en: "+998 (Uzbekistan)"
			}
		});
	},
	worldCountry() {
		return new TableClass({
			'ae': {
				typeClass: 1,
				typeClassLiteral: 'ae',
				it: "Andorra",
				en: "Andorra"
			},
			'ad': {
				typeClass: 2,
				typeClassLiteral: 'ad',
				it: "Emirati Arabi Uniti",
				en: "United Arab Emirates"
			},
			'af': {
				typeClass: 3,
				typeClassLiteral: 'af',
				it: "Afghanistan",
				en: "Afghanistan"
			},
			'ag': {
				typeClass: 4,
				typeClassLiteral: 'ag',
				it: "Antigua e Bermuda",
				en: "Antigua and Barbuda"
			},
			'ai': {
				typeClass: 5,
				typeClassLiteral: 'ai',
				it: "Anguilla",
				en: "Anguilla"
			},
			'al': {
				typeClass: 6,
				typeClassLiteral: 'al',
				it: "Albania",
				en: "Albania"
			},
			'am': {
				typeClass: 7,
				typeClassLiteral: 'am',
				it: "Armenia",
				en: "Armenia"
			},
			'ao': {
				typeClass: 8,
				typeClassLiteral: 'ao',
				it: "Angola",
				en: "Angola"
			},
			'aq': {
				typeClass: 9,
				typeClassLiteral: 'aq',
				it: "Antartide",
				en: "Antarctica"
			},
			'ar': {
				typeClass: 10,
				typeClassLiteral: 'ar',
				it: "Argentina",
				en: "Argentina"
			},
			'as': {
				typeClass: 11,
				typeClassLiteral: 'as',
				it: "Samoa Americane",
				en: "American Samoa"
			},
			'au': {
				typeClass: 12,
				typeClassLiteral: 'au',
				it: "Australia",
				en: "Australia"
			},
			'at': {
				typeClass: 13,
				typeClassLiteral: 'at',
				it: "Austria",
				en: "Austria"
			},
			'aw': {
				typeClass: 14,
				typeClassLiteral: 'aw',
				it: "Aruba",
				en: "Aruba"
			},
			'ax': {
				typeClass: 15,
				typeClassLiteral: 'ax',
				it: "Isole Aland",
				en: "Aland Islands"
			},
			'az': {
				typeClass: 16,
				typeClassLiteral: 'az',
				it: "Azerbaigian",
				en: "Azerbaijan"
			},
			'ba': {
				typeClass: 17,
				typeClassLiteral: 'ba',
				it: "Bosnia ed Erzegovina",
				en: "Bosnia and Herzegovina"
			},
			'bb': {
				typeClass: 18,
				typeClassLiteral: 'bb',
				it: "Barbados",
				en: "Barbados"
			},
			'bd': {
				typeClass: 19,
				typeClassLiteral: 'bd',
				it: "Bangladesh",
				en: "Bangladesh"
			},
			'be': {
				typeClass: 20,
				typeClassLiteral: 'be',
				it: "Belgio",
				en: "Belgium"
			},
			'bf': {
				typeClass: 21,
				typeClassLiteral: 'bf',
				it: "Burkina Faso",
				en: "Burkina Faso"
			},
			'bg': {
				typeClass: 22,
				typeClassLiteral: 'bg',
				it: "Bulgaria",
				en: "Bulgaria"
			},
			'bh': {
				typeClass: 23,
				typeClassLiteral: 'bh',
				it: "Bahrein",
				en: "Bahrain"
			},
			'bi': {
				typeClass: 24,
				typeClassLiteral: 'bi',
				it: "Burundi",
				en: "Burundi"
			},
			'bj': {
				typeClass: 25,
				typeClassLiteral: 'bj',
				it: "Benin",
				en: "Benin"
			},
			'bl': {
				typeClass: 26,
				typeClassLiteral: 'bl',
				it: "Saint-Barthélemy",
				en: "Saint-Barthélemy"
			},
			'bm': {
				typeClass: 27,
				typeClassLiteral: 'bm',
				it: "Bermuda",
				en: "Bermuda"
			},
			'bn': {
				typeClass: 28,
				typeClassLiteral: 'bn',
				it: "Brunei",
				en: "Brunei Darussalam"
			},
			'bo': {
				typeClass: 29,
				typeClassLiteral: 'bo',
				it: "Bolivia",
				en: "Bolivia"
			},
			'bq': {
				typeClass: 30,
				typeClassLiteral: 'bq',
				it: "Isole BES",
				en: "Bonair"
			},
			'br': {
				typeClass: 31,
				typeClassLiteral: 'br',
				it: "Brasile",
				en: "Brazil"
			},
			'bs': {
				typeClass: 32,
				typeClassLiteral: 'bs',
				it: "Bahamas",
				en: "Bahamas"
			},
			'bt': {
				typeClass: 33,
				typeClassLiteral: 'bt',
				it: "Bhutan",
				en: "Bhutan"
			},
			'bv': {
				typeClass: 34,
				typeClassLiteral: 'bv',
				it: "Isola Bouvet",
				en: "Bouvet Island"
			},
			'bw': {
				typeClass: 35,
				typeClassLiteral: 'bw',
				it: "Botswana",
				en: "Botswana"
			},
			'by': {
				typeClass: 36,
				typeClassLiteral: 'by',
				it: "Bielorussia",
				en: "Belarus"
			},
			'bz': {
				typeClass: 37,
				typeClassLiteral: 'bz',
				it: "Belize",
				en: "Belize"
			},
			'ca': {
				typeClass: 38,
				typeClassLiteral: 'ca',
				it: "Canada",
				en: "Canada"
			},
			'cc': {
				typeClass: 39,
				typeClassLiteral: 'cc',
				it: "Isole Coco e Keeling",
				en: "Coco (Keeling) Islands"
			},
			'cd': {
				typeClass: 40,
				typeClassLiteral: 'cd',
				it: "Repubblica Democratica del Congo",
				en: "the Democratic Republic of the Congo"
			},
			'cf': {
				typeClass: 41,
				typeClassLiteral: 'cf',
				it: "Repubblica Centrafricana",
				en: "Central African Republic"
			},
			'cg': {
				typeClass: 42,
				typeClassLiteral: 'cg',
				it: "Congo",
				en: "Congo"
			},
			'ch': {
				typeClass: 43,
				typeClassLiteral: 'ch',
				it: "Svizzera",
				en: "Switzerland"
			},
			'ci': {
				typeClass: 44,
				typeClassLiteral: 'ci',
				it: "Costa d'Avorio",
				en: "Cote d'Ivoire"
			},
			'ck': {
				typeClass: 45,
				typeClassLiteral: 'ck',
				it: "Isole Cook",
				en: "Cook Islands"
			},
			'cl': {
				typeClass: 46,
				typeClassLiteral: 'cl',
				it: "Cile",
				en: "Chile"
			},
			'cm': {
				typeClass: 47,
				typeClassLiteral: 'cm',
				it: "Cameroon",
				en: "Cameroon"
			},
			'cn': {
				typeClass: 48,
				typeClassLiteral: 'cn',
				it: "Cina",
				en: "China"
			},
			'co': {
				typeClass: 49,
				typeClassLiteral: 'co',
				it: "Colombia",
				en: "Colombia"
			},
			'cr': {
				typeClass: 50,
				typeClassLiteral: 'cr',
				it: "Costa Rica",
				en: "Costa Rica"
			},
			'cu': {
				typeClass: 51,
				typeClassLiteral: 'cu',
				it: "Cuba",
				en: "Cuba"
			},
			'cv': {
				typeClass: 52,
				typeClassLiteral: 'cv',
				it: "Capo Verde",
				en: "Cabo Verde"
			},
			'cw': {
				typeClass: 53,
				typeClassLiteral: 'cw',
				it: "Curaçao",
				en: "Curaçao"
			},
			'cx': {
				typeClass: 54,
				typeClassLiteral: 'cx',
				it: "Isola di Natale",
				en: "Christmas Island"
			},
			'cy': {
				typeClass: 55,
				typeClassLiteral: 'cy',
				it: "Cipro",
				en: "Cyprus"
			},
			'cz': {
				typeClass: 56,
				typeClassLiteral: 'cz',
				it: "Cechia",
				en: "Czechia"
			},
			'de': {
				typeClass: 57,
				typeClassLiteral: 'de',
				it: "Germania",
				en: "Germany"
			},
			'dj': {
				typeClass: 58,
				typeClassLiteral: 'dj',
				it: "Gibuti",
				en: "Djibouti"
			},
			'dk': {
				typeClass: 59,
				typeClassLiteral: 'dk',
				it: "Danimarca",
				en: "Denmark"
			},
			'dm': {
				typeClass: 60,
				typeClassLiteral: 'dm',
				it: "Dominica",
				en: "Dominica"
			},
			'do': {
				typeClass: 61,
				typeClassLiteral: 'do',
				it: "Repubblica Dominicana",
				en: "Dominican Republic"
			},
			'dz': {
				typeClass: 62,
				typeClassLiteral: 'dz',
				it: "Algeria",
				en: "Algeria"
			},
			'ec': {
				typeClass: 63,
				typeClassLiteral: 'ec',
				it: "Ecuador",
				en: "Ecuador"
			},
			'ee': {
				typeClass: 64,
				typeClassLiteral: 'ee',
				it: "Estonia",
				en: "Estonia"
			},
			'eg': {
				typeClass: 65,
				typeClassLiteral: 'eg',
				it: "Egitto",
				en: "Egypt"
			},
			'eh': {
				typeClass: 66,
				typeClassLiteral: 'eh',
				it: "Sahara Occidentale",
				en: "Western Sahara"
			},
			'er': {
				typeClass: 67,
				typeClassLiteral: 'er',
				it: "Eritrea",
				en: "Eritrea"
			},
			'es': {
				typeClass: 68,
				typeClassLiteral: 'es',
				it: "Spagna",
				en: "Spain"
			},
			'et': {
				typeClass: 69,
				typeClassLiteral: 'et',
				it: "Etiopia",
				en: "Ethiopia"
			},
			'fi': {
				typeClass: 70,
				typeClassLiteral: 'fi',
				it: "Finlandia",
				en: "Finland"
			},
			'fj': {
				typeClass: 71,
				typeClassLiteral: 'fj',
				it: "Fiji",
				en: "Fiji"
			},
			'fk': {
				typeClass: 72,
				typeClassLiteral: 'fk',
				it: "Isole Falkland",
				en: "Falkland Islands"
			},
			'fm': {
				typeClass: 73,
				typeClassLiteral: 'fm',
				it: "Stati Federati Micronesia",
				en: "Micronesia"
			},
			'fo': {
				typeClass: 74,
				typeClassLiteral: 'fo',
				it: "Isole Far Oer",
				en: "Faroer Islands"
			},
			'fr': {
				typeClass: 75,
				typeClassLiteral: 'fr',
				it: "Francia",
				en: "France"
			},
			'ga': {
				typeClass: 76,
				typeClassLiteral: 'ga',
				it: "Gabon",
				en: "Gabon"
			},
			'gb': {
				typeClass: 77,
				typeClassLiteral: 'gb',
				it: "Regno Unito",
				en: "United Kingdom"
			},
			'gd': {
				typeClass: 78,
				typeClassLiteral: 'gd',
				it: "Granada",
				en: "Grenada"
			},
			'ge': {
				typeClass: 79,
				typeClassLiteral: 'ge',
				it: "Georgia",
				en: "Georgia"
			},
			'gf': {
				typeClass: 80,
				typeClassLiteral: 'gf',
				it: "Guyana Francese",
				en: "French Guiana"
			},
			'gg': {
				typeClass: 81,
				typeClassLiteral: 'gg',
				it: "Guernsey",
				en: "Guernsey"
			},
			'gh': {
				typeClass: 82,
				typeClassLiteral: 'gh',
				it: "Ghana",
				en: "Ghana"
			},
			'gi': {
				typeClass: 83,
				typeClassLiteral: 'gi',
				it: "Gibilterra",
				en: "Gibraltar"
			},
			'gl': {
				typeClass: 84,
				typeClassLiteral: 'gl',
				it: "Groenlandia",
				en: "Greenland"
			},
			'gm': {
				typeClass: 85,
				typeClassLiteral: 'gm',
				it: "Gambia",
				en: "Gambia"
			},
			'gn': {
				typeClass: 86,
				typeClassLiteral: 'gn',
				it: "Guinea",
				en: "Guinea"
			},
			'gp': {
				typeClass: 87,
				typeClassLiteral: 'gp',
				it: "Guadalupa",
				en: "Guadeloupe"
			},
			'gq': {
				typeClass: 88,
				typeClassLiteral: 'gq',
				it: "Guinea Equatoriale",
				en: "Equatorial Guinea"
			},
			'gr': {
				typeClass: 89,
				typeClassLiteral: 'gr',
				it: "Grecia",
				en: "Greece"
			},
			'gs': {
				typeClass: 90,
				typeClassLiteral: 'gs',
				it: "Georgia del Sud",
				en: "South Georgia"
			},
			'gt': {
				typeClass: 91,
				typeClassLiteral: 'gt',
				it: "Guatemala",
				en: "Guatemala"
			},
			'gu': {
				typeClass: 92,
				typeClassLiteral: 'gu',
				it: "Guam",
				en: "Guam"
			},
			'gy': {
				typeClass: 93,
				typeClassLiteral: 'gy',
				it: "Guyana",
				en: "Guyana"
			},
			'hk': {
				typeClass: 94,
				typeClassLiteral: 'hk',
				it: "Hong Kong",
				en: "Hong Konh"
			},
			'hm': {
				typeClass: 95,
				typeClassLiteral: 'hm',
				it: "Isole Heard e McDonald",
				en: "Heard Island and McDonald Islands"
			},
			'hn': {
				typeClass: 96,
				typeClassLiteral: 'hn',
				it: "Honduras",
				en: "Honduras"
			},
			'hr': {
				typeClass: 97,
				typeClassLiteral: 'hr',
				it: "Croatia",
				en: "Croatia"
			},
			'ht': {
				typeClass: 98,
				typeClassLiteral: 'ht',
				it: "Haiti",
				en: "Haiti"
			},
			'hu': {
				typeClass: 99,
				typeClassLiteral: 'hu',
				it: "Ungheria",
				en: "Hungary"
			},
			'id': {
				typeClass: 100,
				typeClassLiteral: 'id',
				it: "Indonesia",
				en: "Indonesia"
			},
			'ie': {
				typeClass: 101,
				typeClassLiteral: 'ie',
				it: "Irlanda",
				en: "Ireland"
			},
			'il': {
				typeClass: 102,
				typeClassLiteral: 'il',
				it: "Israele",
				en: "Israel"
			},
			'im': {
				typeClass: 103,
				typeClassLiteral: 'im',
				it: "Isola di Man",
				en: "Isle of Man"
			},
			'in': {
				typeClass: 104,
				typeClassLiteral: 'in',
				it: "India",
				en: "India"
			},
			'io': {
				typeClass: 105,
				typeClassLiteral: 'io',
				it: "Territori Britannici dell'Oceano Indiano",
				en: "British Indian Ocean Territory"
			},
			'iq': {
				typeClass: 106,
				typeClassLiteral: 'iq',
				it: "Iraq",
				en: "Iraq"
			},
			'ir': {
				typeClass: 107,
				typeClassLiteral: 'ir',
				it: "Iran",
				en: "Iran"
			},
			'is': {
				typeClass: 108,
				typeClassLiteral: 'is',
				it: "Islanda",
				en: "Iceland"
			},
			'it': {
				typeClass: 109,
				typeClassLiteral: 'it',
				it: "Italia",
				en: "Italy"
			},
			'je': {
				typeClass: 110,
				typeClassLiteral: 'je',
				it: "Jersey",
				en: "Jersey"
			},
			'jm': {
				typeClass: 111,
				typeClassLiteral: 'jm',
				it: "Giamaica",
				en: "Jamaica"
			},
			'jo': {
				typeClass: 112,
				typeClassLiteral: 'jo',
				it: "Giordania",
				en: "Jordan"
			},
			'jp': {
				typeClass: 113,
				typeClassLiteral: 'jp',
				it: "Giappone",
				en: "Japan"
			},
			'ke': {
				typeClass: 114,
				typeClassLiteral: 'ke',
				it: "Kenya",
				en: "Kenya"
			},
			'kg': {
				typeClass: 115,
				typeClassLiteral: 'kg',
				it: "Kirghizistan",
				en: "Kyrgyzstan"
			},
			'kh': {
				typeClass: 116,
				typeClassLiteral: 'kh',
				it: "Cambogia",
				en: "Cambodia"
			},
			'ki': {
				typeClass: 117,
				typeClassLiteral: 'ki',
				it: "Kiribati",
				en: "Kiribati"
			},
			'km': {
				typeClass: 118,
				typeClassLiteral: 'km',
				it: "Comore",
				en: "Comoros"
			},
			'kn': {
				typeClass: 119,
				typeClassLiteral: 'kn',
				it: "Saint Kitts and Nevis",
				en: "Saint Kitts and Nevis"
			},
			'kp': {
				typeClass: 120,
				typeClassLiteral: 'kp',
				it: "Corea del Nord",
				en: "North Korea"
			},
			'kr': {
				typeClass: 121,
				typeClassLiteral: 'kr',
				it: "Corea del Sud",
				en: "South Korea"
			},
			'kw': {
				typeClass: 122,
				typeClassLiteral: 'kw',
				it: "Kuwait",
				en: "Kuwait"
			},
			'ky': {
				typeClass: 123,
				typeClassLiteral: 'ky',
				it: "Isole Cayman",
				en: "Cayman Island"
			},
			'kz': {
				typeClass: 124,
				typeClassLiteral: 'kz',
				it: "Kazakistan",
				en: "Kazakhstan"
			},
			'la': {
				typeClass: 125,
				typeClassLiteral: 'la',
				it: "Laos",
				en: "Laos"
			},
			'lb': {
				typeClass: 126,
				typeClassLiteral: 'lb',
				it: "Libano",
				en: "Lebanon"
			},
			'lc': {
				typeClass: 127,
				typeClassLiteral: 'lc',
				it: "Santa Lucia",
				en: "Saint Lucia"
			},
			'li': {
				typeClass: 128,
				typeClassLiteral: 'li',
				it: "Liechtenstein",
				en: "Liechtenstein"
			},
			'lk': {
				typeClass: 129,
				typeClassLiteral: 'lk',
				it: "Sri Lanka",
				en: "Sri Lanka"
			},
			'lr': {
				typeClass: 130,
				typeClassLiteral: 'lr',
				it: "Liberia",
				en: "Liberia"
			},
			'ls': {
				typeClass: 131,
				typeClassLiteral: 'ls',
				it: "Lesotho",
				en: "Lesotho"
			},
			'lt': {
				typeClass: 132,
				typeClassLiteral: 'lt',
				it: "Lituania",
				en: "Lithuania"
			},
			'lu': {
				typeClass: 133,
				typeClassLiteral: 'lu',
				it: "Lussemburgo",
				en: "Luxembourg"
			},
			'lv': {
				typeClass: 134,
				typeClassLiteral: 'lv',
				it: "Lettonia",
				en: "Latvia"
			},
			'ly': {
				typeClass: 135,
				typeClassLiteral: 'ly',
				it: "Libia",
				en: "Libya"
			},
			'ma': {
				typeClass: 136,
				typeClassLiteral: 'ma',
				it: "Marocco",
				en: "Morocco"
			},
			'mc': {
				typeClass: 137,
				typeClassLiteral: 'mc',
				it: "Monaco",
				en: "Monaco"
			},
			'md': {
				typeClass: 138,
				typeClassLiteral: 'md',
				it: "Moldova",
				en: "Moldavia"
			},
			'me': {
				typeClass: 139,
				typeClassLiteral: 'me',
				it: "Montenegro",
				en: "Montenegro"
			},
			'mf': {
				typeClass: 140,
				typeClassLiteral: 'mf',
				it: "Saint Martin",
				en: "Saint Martin"
			},
			'mg': {
				typeClass: 141,
				typeClassLiteral: 'mg',
				it: "Madagascar",
				en: "Madagascar"
			},
			'mh': {
				typeClass: 142,
				typeClassLiteral: 'mh',
				it: "Isole Marshall",
				en: "Marshall Islands"
			},
			'mk': {
				typeClass: 143,
				typeClassLiteral: 'mk',
				it: "Macedonia",
				en: "Macedonia"
			},
			'ml': {
				typeClass: 144,
				typeClassLiteral: 'ml',
				it: "Mali",
				en: "Mali"
			},
			'mm': {
				typeClass: 145,
				typeClassLiteral: 'mm',
				it: "Birmania",
				en: "Myanmar"
			},
			'mn': {
				typeClass: 146,
				typeClassLiteral: 'mn',
				it: "Mongolia",
				en: "Mongolia"
			},
			'mo': {
				typeClass: 147,
				typeClassLiteral: 'mo',
				it: "Macao",
				en: "Macao"
			},
			'mp': {
				typeClass: 148,
				typeClassLiteral: 'mp',
				it: "Isole Marianne Settentrionali",
				en: "Northern Mariana Islands"
			},
			'mq': {
				typeClass: 149,
				typeClassLiteral: 'mq',
				it: "Martinica",
				en: "Martinique"
			},
			'mr': {
				typeClass: 150,
				typeClassLiteral: 'mr',
				it: "Mauritania",
				en: "Mauritania"
			},
			'ms': {
				typeClass: 151,
				typeClassLiteral: 'ms',
				it: "Montserrat",
				en: "Montserrat"
			},
			'mt': {
				typeClass: 152,
				typeClassLiteral: 'mt',
				it: "Malta",
				en: "Malta"
			},
			'mu': {
				typeClass: 153,
				typeClassLiteral: 'mu',
				it: "Mauritius",
				en: "Mauritius"
			},
			'mv': {
				typeClass: 154,
				typeClassLiteral: 'mv',
				it: "Maldive",
				en: "Maldives"
			},
			'mw': {
				typeClass: 155,
				typeClassLiteral: 'mw',
				it: "Malawi",
				en: "Malawi"
			},
			'mx': {
				typeClass: 156,
				typeClassLiteral: 'mx',
				it: "Messico",
				en: "Mexico"
			},
			'my': {
				typeClass: 157,
				typeClassLiteral: 'my',
				it: "Malesia",
				en: "Malaysia"
			},
			'mz': {
				typeClass: 158,
				typeClassLiteral: 'mz',
				it: "Mozambico",
				en: "Mozambique"
			},
			'na': {
				typeClass: 159,
				typeClassLiteral: 'na',
				it: "Namibia",
				en: "Namibia"
			},
			'nc': {
				typeClass: 160,
				typeClassLiteral: 'nc',
				it: "Nuova Caledonia",
				en: "New Caledonia"
			},
			'ne': {
				typeClass: 161,
				typeClassLiteral: 'ne',
				it: "Niger",
				en: "Niger"
			},
			'nf': {
				typeClass: 162,
				typeClassLiteral: 'nf',
				it: "Isola Norfolk",
				en: "Norfolk Island"
			},
			'ng': {
				typeClass: 163,
				typeClassLiteral: 'ng',
				it: "Nigeria",
				en: "Nigeria"
			},
			'ni': {
				typeClass: 164,
				typeClassLiteral: 'ni',
				it: "Nicaragua",
				en: "Nicaragua"
			},
			'nl': {
				typeClass: 165,
				typeClassLiteral: 'nl',
				it: "Paesi Bassi",
				en: "Netherlands"
			},
			'no': {
				typeClass: 166,
				typeClassLiteral: 'no',
				it: "Norvegia",
				en: "Norway"
			},
			'np': {
				typeClass: 167,
				typeClassLiteral: 'np',
				it: "Nepal",
				en: "Nepal"
			},
			'nr': {
				typeClass: 168,
				typeClassLiteral: 'nr',
				it: "Nauru",
				en: "Nauru"
			},
			'nu': {
				typeClass: 169,
				typeClassLiteral: 'nu',
				it: "Niue",
				en: "Niue"
			},
			'nz': {
				typeClass: 170,
				typeClassLiteral: 'nz',
				it: "Nuova Zelanda",
				en: "New Zealand"
			},
			'om': {
				typeClass: 171,
				typeClassLiteral: 'om',
				it: "Oman",
				en: "Oman"
			},
			'pa': {
				typeClass: 172,
				typeClassLiteral: 'pa',
				it: "Panama",
				en: "Panama"
			},
			'pe': {
				typeClass: 173,
				typeClassLiteral: 'pe',
				it: "Per�",
				en: "Peru"
			},
			'pf': {
				typeClass: 174,
				typeClassLiteral: 'pf',
				it: "Polinesia Francese",
				en: "French Polynesia"
			},
			'pg': {
				typeClass: 175,
				typeClassLiteral: 'pg',
				it: "Papua Nuova Guinea",
				en: "Papua New Guinea"
			},
			'ph': {
				typeClass: 176,
				typeClassLiteral: 'ph',
				it: "Filippine",
				en: "Philippines"
			},
			'pk': {
				typeClass: 177,
				typeClassLiteral: 'pk',
				it: "Pakistan",
				en: "Pakistan"
			},
			'pl': {
				typeClass: 178,
				typeClassLiteral: 'pl',
				it: "Polonia",
				en: "Poland"
			},
			'pm': {
				typeClass: 179,
				typeClassLiteral: 'pm',
				it: "Saint Pierre and Miquelon",
				en: "Saint Pierre and Miquelon"
			},
			'pn': {
				typeClass: 180,
				typeClassLiteral: 'pn',
				it: "Isole Pitcairn",
				en: "Pitcairn"
			},
			'pr': {
				typeClass: 181,
				typeClassLiteral: 'pr',
				it: "Porto Rico",
				en: "Puerto Rico"
			},
			'ps': {
				typeClass: 182,
				typeClassLiteral: 'ps',
				it: "Palestina",
				en: "Palestine"
			},
			'pt': {
				typeClass: 183,
				typeClassLiteral: 'pt',
				it: "Portogallo",
				en: "Portugal"
			},
			'pw': {
				typeClass: 184,
				typeClassLiteral: 'pw',
				it: "Palau",
				en: "Palau"
			},
			'py': {
				typeClass: 185,
				typeClassLiteral: 'py',
				it: "Paraguay",
				en: "Paraguay"
			},
			'qa': {
				typeClass: 186,
				typeClassLiteral: 'qa',
				it: "Qatar",
				en: "Qatar"
			},
			're': {
				typeClass: 187,
				typeClassLiteral: 're',
				it: "Riunione",
				en: "Reunion"
			},
			'ro': {
				typeClass: 188,
				typeClassLiteral: 'ro',
				it: "Romania",
				en: "Romania"
			},
			'rs': {
				typeClass: 189,
				typeClassLiteral: 'rs',
				it: "Serbia",
				en: "Serbia"
			},
			'ru': {
				typeClass: 190,
				typeClassLiteral: 'ru',
				it: "Russia",
				en: "Russian"
			},
			'rw': {
				typeClass: 191,
				typeClassLiteral: 'rw',
				it: "Rwanda",
				en: "Rwanda"
			},
			'sa': {
				typeClass: 192,
				typeClassLiteral: 'sa',
				it: "Arabia Saudita",
				en: "Saudi Arabia"
			},
			'sb': {
				typeClass: 193,
				typeClassLiteral: 'sb',
				it: "Isole Solomone",
				en: "Solomone Islands"
			},
			'sc': {
				typeClass: 194,
				typeClassLiteral: 'sc',
				it: "Seychelles",
				en: "Seychelles"
			},
			'sd': {
				typeClass: 195,
				typeClassLiteral: 'sd',
				it: "Sudan",
				en: "Sudan"
			},
			'se': {
				typeClass: 196,
				typeClassLiteral: 'se',
				it: "Svezia",
				en: "Sweden"
			},
			'sg': {
				typeClass: 197,
				typeClassLiteral: 'sg',
				it: "Singapore",
				en: "Singapore"
			},
			'sh': {
				typeClass: 198,
				typeClassLiteral: 'sh',
				it: "Sant'Elena",
				en: "Saint Helena"
			},
			'si': {
				typeClass: 199,
				typeClassLiteral: 'si',
				it: "Slovenia",
				en: "Slovenia"
			},
			'sj': {
				typeClass: 200,
				typeClassLiteral: 'sj',
				it: "Svalbard and Jan Mayen",
				en: "Svalbard and Jan Mayen"
			},
			'sk': {
				typeClass: 201,
				typeClassLiteral: 'sk',
				it: "Slovacchia",
				en: "Slovakia"
			},
			'sl': {
				typeClass: 202,
				typeClassLiteral: 'sl',
				it: "Sierra Leone",
				en: "Sierra Leona"
			},
			'sm': {
				typeClass: 203,
				typeClassLiteral: 'sm',
				it: "San Marino",
				en: "San Marino"
			},
			'sn': {
				typeClass: 204,
				typeClassLiteral: 'sn',
				it: "Senegal",
				en: "Senegal"
			},
			'so': {
				typeClass: 205,
				typeClassLiteral: 'so',
				it: "Somalia",
				en: "Somalia"
			},
			'sr': {
				typeClass: 206,
				typeClassLiteral: 'sr',
				it: "Suriname",
				en: "Suriname"
			},
			'ss': {
				typeClass: 207,
				typeClassLiteral: 'ss',
				it: "Sudan del Sud",
				en: "South Sudan"
			},
			'st': {
				typeClass: 208,
				typeClassLiteral: 'st',
				it: "Sao Tome e Principe",
				en: "Sao Tome e Principe"
			},
			'sv': {
				typeClass: 209,
				typeClassLiteral: 'sv',
				it: "El Salvador",
				en: "El Salvador"
			},
			'sx': {
				typeClass: 210,
				typeClassLiteral: 'sx',
				it: "Sint Maarten",
				en: "Sint Maarten"
			},
			'sy': {
				typeClass: 211,
				typeClassLiteral: 'sy',
				it: "Siria",
				en: "Syria"
			},
			'sz': {
				typeClass: 212,
				typeClassLiteral: 'sz',
				it: "Swaziland",
				en: "Swaziland"
			},
			'tc': {
				typeClass: 213,
				typeClassLiteral: 'tc',
				it: "Isole Turks e Caicos",
				en: "Turks and Caicos Islands"
			},
			'td': {
				typeClass: 214,
				typeClassLiteral: 'td',
				it: "Chad",
				en: "Chad"
			},
			'tf': {
				typeClass: 215,
				typeClassLiteral: 'tf',
				it: "Territorie Francesi del Sud",
				en: "French Souther Territories"
			},
			'tg': {
				typeClass: 216,
				typeClassLiteral: 'tg',
				it: "Togo",
				en: "Togo"
			},
			'th': {
				typeClass: 217,
				typeClassLiteral: 'th',
				it: "Tailandia",
				en: "Thailand"
			},
			'tj': {
				typeClass: 218,
				typeClassLiteral: 'tj',
				it: "Tagikistan",
				en: "Tajikistan"
			},
			'tk': {
				typeClass: 219,
				typeClassLiteral: 'tk',
				it: "Tokelau",
				en: "Tokelau"
			},
			'tl': {
				typeClass: 220,
				typeClassLiteral: 'tl',
				it: "Timor Est",
				en: "Timor Leste"
			},
			'tm': {
				typeClass: 221,
				typeClassLiteral: 'tm',
				it: "Turkmenistan",
				en: "Turkmenistan"
			},
			'tn': {
				typeClass: 222,
				typeClassLiteral: 'tn',
				it: "Tunisia",
				en: "Tunisia"
			},
			'to': {
				typeClass: 223,
				typeClassLiteral: 'to',
				it: "Tonga",
				en: "Tonga"
			},
			'tr': {
				typeClass: 224,
				typeClassLiteral: 'tr',
				it: "Turchia",
				en: "Turkey"
			},
			'tt': {
				typeClass: 225,
				typeClassLiteral: 'tt',
				it: "Trinidad e Tobago",
				en: "Trinidad e Tobago"
			},
			'tv': {
				typeClass: 226,
				typeClassLiteral: 'tv',
				it: "Tuvalu",
				en: "Tuvalu"
			},
			'tw': {
				typeClass: 227,
				typeClassLiteral: 'tw',
				it: "Taiwan",
				en: "Taiwan"
			},
			'tz': {
				typeClass: 228,
				typeClassLiteral: 'tz',
				it: "Tanzania",
				en: "Tanzania"
			},
			'ua': {
				typeClass: 229,
				typeClassLiteral: 'ua',
				it: "Ukraine",
				en: "Ukraine"
			},
			'ug': {
				typeClass: 230,
				typeClassLiteral: 'ug',
				it: "Uganda",
				en: "Uganda"
			},
			'um': {
				typeClass: 231,
				typeClassLiteral: 'um',
				it: "Isole Minori Esterne degli Stati Uniti",
				en: "United States Minor Outlying Islands"
			},
			'us': {
				typeClass: 232,
				typeClassLiteral: 'us',
				it: "Stati Uniti D'America",
				en: "United States of America"
			},
			'uy': {
				typeClass: 233,
				typeClassLiteral: 'uy',
				it: "Uruguay",
				en: "Uruguay"
			},
			'uz': {
				typeClass: 234,
				typeClassLiteral: 'uz',
				it: "Uzbekistan",
				en: "Uzbekistan"
			},
			'va': {
				typeClass: 235,
				typeClassLiteral: 'va',
				it: "Città del Vaticano",
				en: "Holy See"
			},
			'vc': {
				typeClass: 236,
				typeClassLiteral: 'vc',
				it: "Saint Vincent e Grenadine",
				en: "Saint Vincent and Grenadines"
			},
			've': {
				typeClass: 237,
				typeClassLiteral: 've',
				it: "Venezuela",
				en: "Venezuela"
			},
			'vg': {
				typeClass: 238,
				typeClassLiteral: 'vg',
				it: "Isole Vergini Britanniche",
				en: "Virgin Islands British"
			},
			'vi': {
				typeClass: 239,
				typeClassLiteral: 'vi',
				it: "Isole Vergini Americane",
				en: "Virgin Islands US"
			},
			'vn': {
				typeClass: 240,
				typeClassLiteral: 'vn',
				it: "Vietnam",
				en: "Viet Nam"
			},
			'vu': {
				typeClass: 241,
				typeClassLiteral: 'vu',
				it: "Vanuatu",
				en: "Vanuatu"
			},
			'wf': {
				typeClass: 242,
				typeClassLiteral: 'wf',
				it: "Wallis e Futuna",
				en: "Wallis and Futuna"
			},
			'ws': {
				typeClass: 243,
				typeClassLiteral: 'ws',
				it: "Samoa",
				en: "Samoa"
			},
			'ye': {
				typeClass: 244,
				typeClassLiteral: 'ye',
				it: "Yemen",
				en: "Yemen"
			},
			'yt': {
				typeClass: 245,
				typeClassLiteral: 'yt',
				it: "Mayotte",
				en: "Mayotte"
			},
			'za': {
				typeClass: 246,
				typeClassLiteral: 'za',
				it: "Sud Africa",
				en: "South Africa"
			},
			'zm': {
				typeClass: 247,
				typeClassLiteral: 'zm',
				it: "Zambia",
				en: "Zambia"
			},
			'zw': {
				typeClass: 248,
				typeClassLiteral: 'zw',
				it: "Zimbabwe",
				en: "Zimbabwe"
			}
		});
	}
}
